var items = {
  "block.minecraft.acacia_button": "Botwm Acesia",
  "block.minecraft.acacia_door": "Drws Acesia",
  "block.minecraft.acacia_fence": "Ffens Acesia",
  "block.minecraft.acacia_fence_gate": "Gât Ffens Acesia",
  "block.minecraft.acacia_hanging_sign": "Arwydd Crog Acesia",
  "block.minecraft.acacia_leaves": "Dail Acesia",
  "block.minecraft.acacia_log": "Boncyff Acesia",
  "block.minecraft.acacia_planks": "Planciau Acesia",
  "block.minecraft.acacia_pressure_plate": "Gwasglechen Acesia",
  "block.minecraft.acacia_sapling": "Glasbren Acesia",
  "block.minecraft.acacia_shelf": "Silff Acesia",
  "block.minecraft.acacia_sign": "Arwydd Acesia",
  "block.minecraft.acacia_slab": "Slab Acesia",
  "block.minecraft.acacia_stairs": "Grisiau Acesia",
  "block.minecraft.acacia_trapdoor": "Drws Cudd Acesia",
  "block.minecraft.acacia_wall_hanging_sign": "Arwydd Wal Crog Acesia",
  "block.minecraft.acacia_wall_sign": "Arwydd Wal Acesia",
  "block.minecraft.acacia_wood": "Pren Acesia",
  "block.minecraft.activator_rail": "Cledren Actifadydd",
  "block.minecraft.air": "Aer",
  "block.minecraft.allium": "Garllegyn",
  "block.minecraft.amethyst_block": "Bloc Amethyst",
  "block.minecraft.amethyst_cluster": "Clwstwr Amethyst",
  "block.minecraft.ancient_debris": "Malurion Hynafol",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Slab Andesit",
  "block.minecraft.andesite_stairs": "Grisiau Andesit",
  "block.minecraft.andesite_wall": "Wal Andesit",
  "block.minecraft.anvil": "Einion",
  "block.minecraft.attached_melon_stem": "Coesyn Melon Ynghlwm",
  "block.minecraft.attached_pumpkin_stem": "Coesyn Pwmpen Ynghlwm",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Dail Asalea",
  "block.minecraft.azure_bluet": "Gwreiddrudd Las",
  "block.minecraft.bamboo": "Bambŵ",
  "block.minecraft.bamboo_block": "Bloc Bambŵ",
  "block.minecraft.bamboo_button": "Botwm Bambŵ",
  "block.minecraft.bamboo_door": "Drws Bambŵ",
  "block.minecraft.bamboo_fence": "Ffens Fambŵ",
  "block.minecraft.bamboo_fence_gate": "Gât Ffens Fambŵ",
  "block.minecraft.bamboo_hanging_sign": "Arwydd Crog Bambŵ",
  "block.minecraft.bamboo_mosaic": "Mosäig Bambŵ",
  "block.minecraft.bamboo_mosaic_slab": "Slab Mosäig Bambŵ",
  "block.minecraft.bamboo_mosaic_stairs": "Grisiau Mosäig Bambŵ",
  "block.minecraft.bamboo_planks": "Planciau Bambŵ",
  "block.minecraft.bamboo_pressure_plate": "Gwasglechen Bambŵ",
  "block.minecraft.bamboo_sapling": "Blaguryn Bambŵ",
  "block.minecraft.bamboo_shelf": "Silff Bambŵ",
  "block.minecraft.bamboo_sign": "Arwydd Bambŵ",
  "block.minecraft.bamboo_slab": "Slab Bambŵ",
  "block.minecraft.bamboo_stairs": "Grisiau Bambŵ",
  "block.minecraft.bamboo_trapdoor": "Drws Cudd Bambŵ",
  "block.minecraft.bamboo_wall_hanging_sign": "Arwydd Wal Crog Bambŵ",
  "block.minecraft.bamboo_wall_sign": "Arwydd Wal Bambŵ",
  "block.minecraft.banner.base.black": "Maes Cwbwl Ddu",
  "block.minecraft.banner.base.blue": "Maes Cwbwl Las",
  "block.minecraft.banner.base.brown": "Maes Cwbwl Frown",
  "block.minecraft.banner.base.cyan": "Maes Cwbwl Wyrddlas",
  "block.minecraft.banner.base.gray": "Maes Cwbwl Lwyd",
  "block.minecraft.banner.base.green": "Maes Cwbwl Wyrdd",
  "block.minecraft.banner.base.light_blue": "Maes Cwbwl Las Golau",
  "block.minecraft.banner.base.light_gray": "Maes Cwbwl Lwyd Golau",
  "block.minecraft.banner.base.lime": "Maes Cwbwl Leim",
  "block.minecraft.banner.base.magenta": "Maes Cwbwl Fajenta",
  "block.minecraft.banner.base.orange": "Maes Cwbwl Oren",
  "block.minecraft.banner.base.pink": "Maes Cwbwl Binc",
  "block.minecraft.banner.base.purple": "Maes Cwbwl Borffor",
  "block.minecraft.banner.base.red": "Maes Cwbwl Goch",
  "block.minecraft.banner.base.white": "Maes Cwbwl Wyn",
  "block.minecraft.banner.base.yellow": "Maes Cwbwl Felyn",
  "block.minecraft.banner.border.black": "Bordor Du",
  "block.minecraft.banner.border.blue": "Bordor Glas",
  "block.minecraft.banner.border.brown": "Bordor Brown",
  "block.minecraft.banner.border.cyan": "Bordor Gwyrddlas",
  "block.minecraft.banner.border.gray": "Bordor Llwyd",
  "block.minecraft.banner.border.green": "Bordor Gwyrdd",
  "block.minecraft.banner.border.light_blue": "Bordor Glas Golau",
  "block.minecraft.banner.border.light_gray": "Bordor Llwyd Golau",
  "block.minecraft.banner.border.lime": "Bordor Leim",
  "block.minecraft.banner.border.magenta": "Bordor Majenta",
  "block.minecraft.banner.border.orange": "Bordor Oren",
  "block.minecraft.banner.border.pink": "Bordor Pinc",
  "block.minecraft.banner.border.purple": "Bordor Porffor",
  "block.minecraft.banner.border.red": "Bordor Coch",
  "block.minecraft.banner.border.white": "Bordor Gwyn",
  "block.minecraft.banner.border.yellow": "Bordor Melyn",
  "block.minecraft.banner.bricks.black": "Maes Du Saernïwyd",
  "block.minecraft.banner.bricks.blue": "Maes Glas Saernïwyd",
  "block.minecraft.banner.bricks.brown": "Maes Brown Saernïwyd",
  "block.minecraft.banner.bricks.cyan": "Maes Gwyrddlas Saernïwyd",
  "block.minecraft.banner.bricks.gray": "Maes Llwyd Saernïwyd",
  "block.minecraft.banner.bricks.green": "Maes Gwyrdd Saernïwyd",
  "block.minecraft.banner.bricks.light_blue": "Maes Glas Golau Saernïwyd",
  "block.minecraft.banner.bricks.light_gray": "Maes Llwyd Golau Saernïwyd",
  "block.minecraft.banner.bricks.lime": "Maes Leim Saernïwyd",
  "block.minecraft.banner.bricks.magenta": "Maes Majenta Saernïwyd",
  "block.minecraft.banner.bricks.orange": "Maes Oren Saernïwyd",
  "block.minecraft.banner.bricks.pink": "Maes Pinc Saernïwyd",
  "block.minecraft.banner.bricks.purple": "Maes Porffor Saernïwyd",
  "block.minecraft.banner.bricks.red": "Maes Coch Saernïwyd",
  "block.minecraft.banner.bricks.white": "Maes Gwyn Saernïwyd",
  "block.minecraft.banner.bricks.yellow": "Maes Melyn Saernïwyd",
  "block.minecraft.banner.circle.black": "Cylchig Ddu",
  "block.minecraft.banner.circle.blue": "Cylchig Las",
  "block.minecraft.banner.circle.brown": "Cylchig Frown",
  "block.minecraft.banner.circle.cyan": "Cylchig Wyrddlas",
  "block.minecraft.banner.circle.gray": "Cylchig Llwyd",
  "block.minecraft.banner.circle.green": "Cylchig Werdd",
  "block.minecraft.banner.circle.light_blue": "Cylchig Las Golau",
  "block.minecraft.banner.circle.light_gray": "Cylchig Llwyd Golau",
  "block.minecraft.banner.circle.lime": "Cylchig Leim",
  "block.minecraft.banner.circle.magenta": "Cylchig Majenta",
  "block.minecraft.banner.circle.orange": "Cylchig Oren",
  "block.minecraft.banner.circle.pink": "Cylchig Binc",
  "block.minecraft.banner.circle.purple": "Cylchig Borffor",
  "block.minecraft.banner.circle.red": "Cylchig Goch",
  "block.minecraft.banner.circle.white": "Cylchig Wen",
  "block.minecraft.banner.circle.yellow": "Cylchig Felen",
  "block.minecraft.banner.creeper.black": "Luws Creeper Du",
  "block.minecraft.banner.creeper.blue": "Luws Creeper Glas",
  "block.minecraft.banner.creeper.brown": "Luws Creeper Brown",
  "block.minecraft.banner.creeper.cyan": "Luws Creeper Gwyrddlas",
  "block.minecraft.banner.creeper.gray": "Luws Creeper Llwyd",
  "block.minecraft.banner.creeper.green": "Luws Creeper Gwyrdd",
  "block.minecraft.banner.creeper.light_blue": "Luws Creeper Glas Golau",
  "block.minecraft.banner.creeper.light_gray": "Luws Creeper Llwyd Golau",
  "block.minecraft.banner.creeper.lime": "Luws Creeper Leim",
  "block.minecraft.banner.creeper.magenta": "Luws Creeper Majenta",
  "block.minecraft.banner.creeper.orange": "Luws Creeper Oren",
  "block.minecraft.banner.creeper.pink": "Luws Creeper Pinc",
  "block.minecraft.banner.creeper.purple": "Luws Creeper Porffor",
  "block.minecraft.banner.creeper.red": "Luws Creeper Coch",
  "block.minecraft.banner.creeper.white": "Luws Creeper Gwyn",
  "block.minecraft.banner.creeper.yellow": "Luws Creeper Melyn",
  "block.minecraft.banner.cross.black": "Sawtyr Du",
  "block.minecraft.banner.cross.blue": "Sawtyr Glas",
  "block.minecraft.banner.cross.brown": "Sawtyr Brown",
  "block.minecraft.banner.cross.cyan": "Sawtyr Gwyrddlas",
  "block.minecraft.banner.cross.gray": "Sawtyr Llwyd",
  "block.minecraft.banner.cross.green": "Sawtyr Gwyrdd",
  "block.minecraft.banner.cross.light_blue": "Sawtyr Glas Golau",
  "block.minecraft.banner.cross.light_gray": "Sawtyr Llwyd Golau",
  "block.minecraft.banner.cross.lime": "Sawtyr Leim",
  "block.minecraft.banner.cross.magenta": "Sawtyr Majenta",
  "block.minecraft.banner.cross.orange": "Sawtyr Oren",
  "block.minecraft.banner.cross.pink": "Sawtyr Pinc",
  "block.minecraft.banner.cross.purple": "Sawtyr Porffor",
  "block.minecraft.banner.cross.red": "Sawtyr Coch",
  "block.minecraft.banner.cross.white": "Sawtyr Gwyn",
  "block.minecraft.banner.cross.yellow": "Sawtyr Melyn",
  "block.minecraft.banner.curly_border.black": "Bordor Du Bylchog",
  "block.minecraft.banner.curly_border.blue": "Bordor Glas Bylchog",
  "block.minecraft.banner.curly_border.brown": "Bordor Brown Bylchog",
  "block.minecraft.banner.curly_border.cyan": "Bordor Gwyrddlas Bylchog",
  "block.minecraft.banner.curly_border.gray": "Bordor Llwyd Bylchog",
  "block.minecraft.banner.curly_border.green": "Bordor Gwyrdd Bylchog",
  "block.minecraft.banner.curly_border.light_blue": "Bordor Glas Golau Bylchog",
  "block.minecraft.banner.curly_border.light_gray": "Bordor Llwyd Golau Bylchog",
  "block.minecraft.banner.curly_border.lime": "Bordor Leim Bylchog",
  "block.minecraft.banner.curly_border.magenta": "Bordor Majenta Bylchog",
  "block.minecraft.banner.curly_border.orange": "Bordor Oren Bylchog",
  "block.minecraft.banner.curly_border.pink": "Bordor Pinc Bylchog",
  "block.minecraft.banner.curly_border.purple": "Bordor Porffor Bylchog",
  "block.minecraft.banner.curly_border.red": "Bordor Coch Bylchog",
  "block.minecraft.banner.curly_border.white": "Bordor Gwyn Bylchog",
  "block.minecraft.banner.curly_border.yellow": "Bordor Melyn Bylchog",
  "block.minecraft.banner.diagonal_left.black": "Du'n Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.blue": "Glas Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.brown": "Brown Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.cyan": "Gwyrddlas Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.gray": "Llwyd Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.green": "Gwyrdd Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.light_blue": "Glas Golau'n Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.light_gray": "Llwyd Golau'n Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.lime": "Leim Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.magenta": "Majenta'n Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.orange": "Oren Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.pink": "Pinc Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.purple": "Porffor Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.red": "Coch Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.white": "Gwyn Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_left.yellow": "Melyn Yn Groeslinol Wrthdro",
  "block.minecraft.banner.diagonal_right.black": "Du'n Groeslinol",
  "block.minecraft.banner.diagonal_right.blue": "Glas Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.brown": "Brown Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.cyan": "Gwyrddlas Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.gray": "Llwyd Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.green": "Gwyrdd Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.light_blue": "Glas Golau'n Groeslinol",
  "block.minecraft.banner.diagonal_right.light_gray": "Llwyd Golau'n Groeslinol",
  "block.minecraft.banner.diagonal_right.lime": "Leim Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.magenta": "Majenta'n Groeslinol",
  "block.minecraft.banner.diagonal_right.orange": "Oren Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.pink": "Pinc Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.purple": "Porffor Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.red": "Coch Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.white": "Gwyn Yn Groeslinol",
  "block.minecraft.banner.diagonal_right.yellow": "Melyn Yn Groeslinol",
  "block.minecraft.banner.diagonal_up_left.black": "Du'n Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.blue": "Glas Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.brown": "Brown Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.cyan": "Gwyrddlas Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.gray": "Llwyd Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.green": "Gwyrdd Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Glas Golau'n Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Llwyd Golau'n Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.lime": "Leim Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.magenta": "Majenta'n Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.orange": "Oren Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.pink": "Pinc Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.purple": "Porffor Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.red": "Coch Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.white": "Gwyn Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_left.yellow": "Melyn Yn Groeslinol Traphen",
  "block.minecraft.banner.diagonal_up_right.black": "Du'n Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.blue": "Glas Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.brown": "Brown Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.cyan": "Gwyrddlas Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.gray": "Llwyd Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.green": "Gwyrdd Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Glas Golau'n Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Llwyd Golau'n Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.lime": "Leim Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.magenta": "Majenta'n Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.orange": "Oren Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.pink": "Pinc Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.purple": "Porffor Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.red": "Coch Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.white": "Gwyn Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.diagonal_up_right.yellow": "Melyn Yn Groeslinol Wrthdro Traphen",
  "block.minecraft.banner.flow.black": "Llif Du",
  "block.minecraft.banner.flow.blue": "Llif Glas",
  "block.minecraft.banner.flow.brown": "Llif Brown",
  "block.minecraft.banner.flow.cyan": "Llif Gwyrddlas",
  "block.minecraft.banner.flow.gray": "Llif Llwyd",
  "block.minecraft.banner.flow.green": "Llif Gwyrdd",
  "block.minecraft.banner.flow.light_blue": "Llif Glas Golau",
  "block.minecraft.banner.flow.light_gray": "Llif Llwyd Golau",
  "block.minecraft.banner.flow.lime": "Llif Leim",
  "block.minecraft.banner.flow.magenta": "Llif Majenta",
  "block.minecraft.banner.flow.orange": "Llif Oren",
  "block.minecraft.banner.flow.pink": "Llif Pinc",
  "block.minecraft.banner.flow.purple": "Llif Porffor",
  "block.minecraft.banner.flow.red": "Llif Coch",
  "block.minecraft.banner.flow.white": "Llif Gwyn",
  "block.minecraft.banner.flow.yellow": "Llif Melyn",
  "block.minecraft.banner.flower.black": "Luws Blodyn Du",
  "block.minecraft.banner.flower.blue": "Luws Blodyn Glas",
  "block.minecraft.banner.flower.brown": "Luws Blodyn Brown",
  "block.minecraft.banner.flower.cyan": "Luws Blodyn Gwyrddlas",
  "block.minecraft.banner.flower.gray": "Luws Blodyn Llwyd",
  "block.minecraft.banner.flower.green": "Luws Blodyn Gwyrdd",
  "block.minecraft.banner.flower.light_blue": "Luws Blodyn Glas Golau",
  "block.minecraft.banner.flower.light_gray": "Luws Blodyn Llwyd Golau",
  "block.minecraft.banner.flower.lime": "Luws Blodyn Leim",
  "block.minecraft.banner.flower.magenta": "Luws Blodyn Majenta",
  "block.minecraft.banner.flower.orange": "Luws Blodyn Oren",
  "block.minecraft.banner.flower.pink": "Luws Blodyn Pinc",
  "block.minecraft.banner.flower.purple": "Luws Blodyn Porffor",
  "block.minecraft.banner.flower.red": "Luws Blodyn Coch",
  "block.minecraft.banner.flower.white": "Luws Blodyn Gwyn",
  "block.minecraft.banner.flower.yellow": "Luws Blodyn Melyn",
  "block.minecraft.banner.globe.black": "Glôb Ddu",
  "block.minecraft.banner.globe.blue": "Glôb Las",
  "block.minecraft.banner.globe.brown": "Glôb Frown",
  "block.minecraft.banner.globe.cyan": "Glôb Werddlas",
  "block.minecraft.banner.globe.gray": "Glôb Lwyd",
  "block.minecraft.banner.globe.green": "Glôb Werdd",
  "block.minecraft.banner.globe.light_blue": "Glôb Las Golau",
  "block.minecraft.banner.globe.light_gray": "Glôb Lwyd Golau",
  "block.minecraft.banner.globe.lime": "Glôb Leim",
  "block.minecraft.banner.globe.magenta": "Glôb Fajenta",
  "block.minecraft.banner.globe.orange": "Glôb Oren",
  "block.minecraft.banner.globe.pink": "Glôb Binc",
  "block.minecraft.banner.globe.purple": "Glôb Borffor",
  "block.minecraft.banner.globe.red": "Glôb Goch",
  "block.minecraft.banner.globe.white": "Glôb Wen",
  "block.minecraft.banner.globe.yellow": "Glôb Felen",
  "block.minecraft.banner.gradient.black": "Graddiant Du",
  "block.minecraft.banner.gradient.blue": "Graddiant Glas",
  "block.minecraft.banner.gradient.brown": "Graddiant Brown",
  "block.minecraft.banner.gradient.cyan": "Graddiant Gwyrddlas",
  "block.minecraft.banner.gradient.gray": "Graddiant Llwyd",
  "block.minecraft.banner.gradient.green": "Graddiant Gwyrdd",
  "block.minecraft.banner.gradient.light_blue": "Graddiant Glas Golau",
  "block.minecraft.banner.gradient.light_gray": "Graddiant Llwyd Golau",
  "block.minecraft.banner.gradient.lime": "Graddiant Leim",
  "block.minecraft.banner.gradient.magenta": "Graddiant Majenta",
  "block.minecraft.banner.gradient.orange": "Graddiant Oren",
  "block.minecraft.banner.gradient.pink": "Graddiant Pinc",
  "block.minecraft.banner.gradient.purple": "Graddiant Porffor",
  "block.minecraft.banner.gradient.red": "Graddiant Coch",
  "block.minecraft.banner.gradient.white": "Graddiant Gwyn",
  "block.minecraft.banner.gradient.yellow": "Graddiant Melyn",
  "block.minecraft.banner.gradient_up.black": "Graddiant Sail Du",
  "block.minecraft.banner.gradient_up.blue": "Graddiant Sail Glas",
  "block.minecraft.banner.gradient_up.brown": "Graddiant Sail Brown",
  "block.minecraft.banner.gradient_up.cyan": "Graddiant Sail Gwyrddlas",
  "block.minecraft.banner.gradient_up.gray": "Graddiant Sail Llwyd",
  "block.minecraft.banner.gradient_up.green": "Graddiant Sail Gwyrdd",
  "block.minecraft.banner.gradient_up.light_blue": "Graddiant Sail Glas Golau",
  "block.minecraft.banner.gradient_up.light_gray": "Graddiant Sail Llwyd Golau",
  "block.minecraft.banner.gradient_up.lime": "Graddiant Sail Leim",
  "block.minecraft.banner.gradient_up.magenta": "Graddiant Sail Majenta",
  "block.minecraft.banner.gradient_up.orange": "Graddiant Sail Oren",
  "block.minecraft.banner.gradient_up.pink": "Graddiant Sail Pinc",
  "block.minecraft.banner.gradient_up.purple": "Graddiant Sail Porffor",
  "block.minecraft.banner.gradient_up.red": "Graddiant Sail Coch",
  "block.minecraft.banner.gradient_up.white": "Graddiant Sail Gwyn",
  "block.minecraft.banner.gradient_up.yellow": "Graddiant Sail Melyn",
  "block.minecraft.banner.guster.black": "Hwrdd Du",
  "block.minecraft.banner.guster.blue": "Hwrdd Glas",
  "block.minecraft.banner.guster.brown": "Hwrdd Brown",
  "block.minecraft.banner.guster.cyan": "Hwrdd Gwyrddlas",
  "block.minecraft.banner.guster.gray": "Hwrdd Llwyd",
  "block.minecraft.banner.guster.green": "Hwrdd Gwyrdd",
  "block.minecraft.banner.guster.light_blue": "Hwrdd Glas Golau",
  "block.minecraft.banner.guster.light_gray": "Hwrdd Llwyd Golau",
  "block.minecraft.banner.guster.lime": "Hwrdd Leim",
  "block.minecraft.banner.guster.magenta": "Hwrdd Majenta",
  "block.minecraft.banner.guster.orange": "Hwrdd Oren",
  "block.minecraft.banner.guster.pink": "Hwrdd Pinc",
  "block.minecraft.banner.guster.purple": "Hwrdd Porffor",
  "block.minecraft.banner.guster.red": "Hwrdd Coch",
  "block.minecraft.banner.guster.white": "Hwrdd Gwyn",
  "block.minecraft.banner.guster.yellow": "Hwrdd Melyn",
  "block.minecraft.banner.half_horizontal.black": "Bar Per Du",
  "block.minecraft.banner.half_horizontal.blue": "Bar Per Glas",
  "block.minecraft.banner.half_horizontal.brown": "Bar Per Brown",
  "block.minecraft.banner.half_horizontal.cyan": "Bar Per Gwyrddlas",
  "block.minecraft.banner.half_horizontal.gray": "Bar Per Llwyd",
  "block.minecraft.banner.half_horizontal.green": "Bar Per Gwyrdd",
  "block.minecraft.banner.half_horizontal.light_blue": "Bar Per Glas Golau",
  "block.minecraft.banner.half_horizontal.light_gray": "Bar Per Llwyd Golau",
  "block.minecraft.banner.half_horizontal.lime": "Bar Per Leim",
  "block.minecraft.banner.half_horizontal.magenta": "Bar Per Majenta",
  "block.minecraft.banner.half_horizontal.orange": "Bar Per Oren",
  "block.minecraft.banner.half_horizontal.pink": "Bar Per Pinc",
  "block.minecraft.banner.half_horizontal.purple": "Bar Per Porffor",
  "block.minecraft.banner.half_horizontal.red": "Bar Per Coch",
  "block.minecraft.banner.half_horizontal.white": "Bar Per Gwyn",
  "block.minecraft.banner.half_horizontal.yellow": "Bar Per Melyn",
  "block.minecraft.banner.half_horizontal_bottom.black": "Bar Per Du Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Bar Per Glas Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Bar Per Brown Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Bar Per Gwyrddlas Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Bar Per Llwyd Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.green": "Bar Per Gwyrdd Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Bar Per Glas Golau Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Bar Per Llwyd Golau Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Bar Per Leim Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Bar Per Majenta Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Bar Per Oren Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Bar Per Pinc Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Bar Per Porffor Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.red": "Bar Per Coch Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.white": "Bar Per Gwyn Gwrthdroëdig",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Bar Per Melyn Gwrthdroëdig",
  "block.minecraft.banner.half_vertical.black": "Pâl Per Du",
  "block.minecraft.banner.half_vertical.blue": "Pâl Per Glas",
  "block.minecraft.banner.half_vertical.brown": "Pâl Per Brown",
  "block.minecraft.banner.half_vertical.cyan": "Pâl Per Gwyrddlas",
  "block.minecraft.banner.half_vertical.gray": "Pâl Per Llwyd",
  "block.minecraft.banner.half_vertical.green": "Pâl Per Gwyrdd",
  "block.minecraft.banner.half_vertical.light_blue": "Pâl Per Glas Golau",
  "block.minecraft.banner.half_vertical.light_gray": "Pâl Per Llwyd Golau",
  "block.minecraft.banner.half_vertical.lime": "Pâl Per Leim",
  "block.minecraft.banner.half_vertical.magenta": "Pâl Per Majenta",
  "block.minecraft.banner.half_vertical.orange": "Pâl Per Oren",
  "block.minecraft.banner.half_vertical.pink": "Pâl Per Pinc",
  "block.minecraft.banner.half_vertical.purple": "Pâl Per Porffor",
  "block.minecraft.banner.half_vertical.red": "Pâl Per Coch",
  "block.minecraft.banner.half_vertical.white": "Pâl Per Gwyn",
  "block.minecraft.banner.half_vertical.yellow": "Pâl Per Melyn",
  "block.minecraft.banner.half_vertical_right.black": "Pâl Per Du Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.blue": "Pâl Per Glas Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.brown": "Pâl Per Brown Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.cyan": "Pâl Per Gwyrddlas Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.gray": "Pâl Per Llwyd Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.green": "Pâl Per Gwyrdd Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.light_blue": "Pâl Per Glas Golau Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.light_gray": "Pâl Per Llwyd Golau Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.lime": "Pâl Per Leim Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.magenta": "Pâl Per Majenta Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.orange": "Pâl Per Oren Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.pink": "Pâl Per Pinc Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.purple": "Pâl Per Porffor Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.red": "Pâl Per Coch Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.white": "Pâl Per Gwyn Gwrthdroëdig",
  "block.minecraft.banner.half_vertical_right.yellow": "Pâl Per Melyn Gwrthdroëdig",
  "block.minecraft.banner.mojang.black": "Peth Du",
  "block.minecraft.banner.mojang.blue": "Peth Glas",
  "block.minecraft.banner.mojang.brown": "Peth Brown",
  "block.minecraft.banner.mojang.cyan": "Peth Gwyrddlas",
  "block.minecraft.banner.mojang.gray": "Peth Llwyd",
  "block.minecraft.banner.mojang.green": "Peth Gwyrdd",
  "block.minecraft.banner.mojang.light_blue": "Peth Glas Golau",
  "block.minecraft.banner.mojang.light_gray": "Peth Llwyd Golau",
  "block.minecraft.banner.mojang.lime": "Peth Leim",
  "block.minecraft.banner.mojang.magenta": "Peth Majenta",
  "block.minecraft.banner.mojang.orange": "Peth Oren",
  "block.minecraft.banner.mojang.pink": "Peth Pinc",
  "block.minecraft.banner.mojang.purple": "Peth Porffor",
  "block.minecraft.banner.mojang.red": "Peth Coch",
  "block.minecraft.banner.mojang.white": "Peth Gwyn",
  "block.minecraft.banner.mojang.yellow": "Peth Melyn",
  "block.minecraft.banner.piglin.black": "Trwyn Du",
  "block.minecraft.banner.piglin.blue": "Trwyn Glas",
  "block.minecraft.banner.piglin.brown": "Trwyn Brown",
  "block.minecraft.banner.piglin.cyan": "Trwyn Gwyrddlas",
  "block.minecraft.banner.piglin.gray": "Trwyn Llwyd",
  "block.minecraft.banner.piglin.green": "Trwyn Gwyrdd",
  "block.minecraft.banner.piglin.light_blue": "Trwyn Glas Golau",
  "block.minecraft.banner.piglin.light_gray": "Trwyn Llwyd Golau",
  "block.minecraft.banner.piglin.lime": "Trwyn Leim",
  "block.minecraft.banner.piglin.magenta": "Trwyn Majenta",
  "block.minecraft.banner.piglin.orange": "Trwyn Oren",
  "block.minecraft.banner.piglin.pink": "Trwyn Pinc",
  "block.minecraft.banner.piglin.purple": "Trwyn Porffor",
  "block.minecraft.banner.piglin.red": "Trwyn Coch",
  "block.minecraft.banner.piglin.white": "Trwyn Gwyn",
  "block.minecraft.banner.piglin.yellow": "Trwyn Melyn",
  "block.minecraft.banner.rhombus.black": "Sgwâr Du",
  "block.minecraft.banner.rhombus.blue": "Sgwâr Glas",
  "block.minecraft.banner.rhombus.brown": "Sgwâr Brown",
  "block.minecraft.banner.rhombus.cyan": "Sgwâr Gwyrddlas",
  "block.minecraft.banner.rhombus.gray": "Sgwâr Llwyd",
  "block.minecraft.banner.rhombus.green": "Sgwâr Gwyrdd",
  "block.minecraft.banner.rhombus.light_blue": "Sgwâr Glas Golau",
  "block.minecraft.banner.rhombus.light_gray": "Sgwâr Llwyd Golau",
  "block.minecraft.banner.rhombus.lime": "Sgwâr Leim",
  "block.minecraft.banner.rhombus.magenta": "Sgwâr Majenta",
  "block.minecraft.banner.rhombus.orange": "Sgwâr Oren",
  "block.minecraft.banner.rhombus.pink": "Sgwâr Pinc",
  "block.minecraft.banner.rhombus.purple": "Sgwâr Porffor",
  "block.minecraft.banner.rhombus.red": "Sgwâr Coch",
  "block.minecraft.banner.rhombus.white": "Sgwâr Gwyn",
  "block.minecraft.banner.rhombus.yellow": "Sgwâr Melyn",
  "block.minecraft.banner.skull.black": "Luws Penglog Du",
  "block.minecraft.banner.skull.blue": "Luws Penglog Glas",
  "block.minecraft.banner.skull.brown": "Luws Penglog Brown",
  "block.minecraft.banner.skull.cyan": "Luws Penglog Gwyrddlas",
  "block.minecraft.banner.skull.gray": "Luws Penglog Llwyd",
  "block.minecraft.banner.skull.green": "Luws Penglog Gwyrdd",
  "block.minecraft.banner.skull.light_blue": "Luws Penglog Glas Golau",
  "block.minecraft.banner.skull.light_gray": "Luws Penglog Llwyd Golau",
  "block.minecraft.banner.skull.lime": "Luws Penglog Leim",
  "block.minecraft.banner.skull.magenta": "Luws Penglog Majenta",
  "block.minecraft.banner.skull.orange": "Luws Penglog Oren",
  "block.minecraft.banner.skull.pink": "Luws Penglog Pinc",
  "block.minecraft.banner.skull.purple": "Luws Penglog Porffor",
  "block.minecraft.banner.skull.red": "Luws Penglog Coch",
  "block.minecraft.banner.skull.white": "Luws Penglog Gwyn",
  "block.minecraft.banner.skull.yellow": "Luws Penglog Melyn",
  "block.minecraft.banner.small_stripes.black": "Du Palisiog",
  "block.minecraft.banner.small_stripes.blue": "Glas Palisiog",
  "block.minecraft.banner.small_stripes.brown": "Brown Palisiog",
  "block.minecraft.banner.small_stripes.cyan": "Gwyrddlas Palisiog",
  "block.minecraft.banner.small_stripes.gray": "Llwyd Palisiog",
  "block.minecraft.banner.small_stripes.green": "Gwyrdd Palisiog",
  "block.minecraft.banner.small_stripes.light_blue": "Glas Golau Palisiog",
  "block.minecraft.banner.small_stripes.light_gray": "Llwyd Golau Palisiog",
  "block.minecraft.banner.small_stripes.lime": "Leim Palisiog",
  "block.minecraft.banner.small_stripes.magenta": "Majenta Palisiog",
  "block.minecraft.banner.small_stripes.orange": "Oren Palisiog",
  "block.minecraft.banner.small_stripes.pink": "Pinc Palisiog",
  "block.minecraft.banner.small_stripes.purple": "Porffor Palisiog",
  "block.minecraft.banner.small_stripes.red": "Coch Palisiog",
  "block.minecraft.banner.small_stripes.white": "Gwyn Palisiog",
  "block.minecraft.banner.small_stripes.yellow": "Melyn Palisiog",
  "block.minecraft.banner.square_bottom_left.black": "Canton Sail Du Dehau",
  "block.minecraft.banner.square_bottom_left.blue": "Canton Sail Glas Dehau",
  "block.minecraft.banner.square_bottom_left.brown": "Canton Sail Brown Dehau",
  "block.minecraft.banner.square_bottom_left.cyan": "Canton Sail Gwyrddlas Dehau",
  "block.minecraft.banner.square_bottom_left.gray": "Canton Sail Llwyd Dehau",
  "block.minecraft.banner.square_bottom_left.green": "Canton Sail Gwyrdd Dehau",
  "block.minecraft.banner.square_bottom_left.light_blue": "Canton Sail Glas Golau Dehau",
  "block.minecraft.banner.square_bottom_left.light_gray": "Canton Sail Llwyd Golau Dehau",
  "block.minecraft.banner.square_bottom_left.lime": "Canton Sail Leim Dehau",
  "block.minecraft.banner.square_bottom_left.magenta": "Canton Sail Majenta Dehau",
  "block.minecraft.banner.square_bottom_left.orange": "Canton Sail Oren Dehau",
  "block.minecraft.banner.square_bottom_left.pink": "Canton Sail Pinc Dehau",
  "block.minecraft.banner.square_bottom_left.purple": "Canton Sail Porffor Dehau",
  "block.minecraft.banner.square_bottom_left.red": "Canton Sail Coch Dehau",
  "block.minecraft.banner.square_bottom_left.white": "Canton Sail Gwyn Dehau",
  "block.minecraft.banner.square_bottom_left.yellow": "Canton Sail Melyn Dehau",
  "block.minecraft.banner.square_bottom_right.black": "Canton Sail Du o Chwith",
  "block.minecraft.banner.square_bottom_right.blue": "Canton Sail Glas o Chwith",
  "block.minecraft.banner.square_bottom_right.brown": "Canton Sail Brown o Chwith",
  "block.minecraft.banner.square_bottom_right.cyan": "Canton Sail Gwyrddlas o Chwith",
  "block.minecraft.banner.square_bottom_right.gray": "Canton Sail Llwyd o Chwith",
  "block.minecraft.banner.square_bottom_right.green": "Canton Sail Gwyrdd o Chwith",
  "block.minecraft.banner.square_bottom_right.light_blue": "Canton Sail Glas Golau o Chwith",
  "block.minecraft.banner.square_bottom_right.light_gray": "Canton Sail Llwyd Golau o Chwith",
  "block.minecraft.banner.square_bottom_right.lime": "Canton Sail Leim o Chwith",
  "block.minecraft.banner.square_bottom_right.magenta": "Canton Sail Majenta o Chwith",
  "block.minecraft.banner.square_bottom_right.orange": "Canton Sail Oren o Chwith",
  "block.minecraft.banner.square_bottom_right.pink": "Canton Sail Pinc o Chwith",
  "block.minecraft.banner.square_bottom_right.purple": "Canton Sail Porffor o Chwith",
  "block.minecraft.banner.square_bottom_right.red": "Canton Sail Coch o Chwith",
  "block.minecraft.banner.square_bottom_right.white": "Canton Sail Gwyn o Chwith",
  "block.minecraft.banner.square_bottom_right.yellow": "Canton Sail Melyn o Chwith",
  "block.minecraft.banner.square_top_left.black": "Canton Prif Ddehau Du",
  "block.minecraft.banner.square_top_left.blue": "Canton Prif Ddehau Glas",
  "block.minecraft.banner.square_top_left.brown": "Canton Prif Ddehau Brown",
  "block.minecraft.banner.square_top_left.cyan": "Canton Prif Ddehau Gwyrddlas",
  "block.minecraft.banner.square_top_left.gray": "Canton Prif Ddehau Llwyd",
  "block.minecraft.banner.square_top_left.green": "Canton Prif Ddehau Gwyrdd",
  "block.minecraft.banner.square_top_left.light_blue": "Canton Prif Ddehau Glas Golau",
  "block.minecraft.banner.square_top_left.light_gray": "Canton Prif Ddehau Llwyd Golau",
  "block.minecraft.banner.square_top_left.lime": "Canton Prif Ddehau Leim",
  "block.minecraft.banner.square_top_left.magenta": "Canton Prif Ddehau Majenta",
  "block.minecraft.banner.square_top_left.orange": "Canton Prif Ddehau Oren",
  "block.minecraft.banner.square_top_left.pink": "Canton Prif Ddehau Pinc",
  "block.minecraft.banner.square_top_left.purple": "Canton Prif Ddehau Porffor",
  "block.minecraft.banner.square_top_left.red": "Canton Prif Ddehau Coch",
  "block.minecraft.banner.square_top_left.white": "Canton Prif Ddehau Gwyn",
  "block.minecraft.banner.square_top_left.yellow": "Canton Prif Ddehau Melyn",
  "block.minecraft.banner.square_top_right.black": "Canton Siff Du o Chwith",
  "block.minecraft.banner.square_top_right.blue": "Canton Siff Glas o Chwith",
  "block.minecraft.banner.square_top_right.brown": "Canton Siff Brown o Chwith",
  "block.minecraft.banner.square_top_right.cyan": "Canton Siff Gwyrddlas o Chwith",
  "block.minecraft.banner.square_top_right.gray": "Canton Siff Llwyd o Chwith",
  "block.minecraft.banner.square_top_right.green": "Canton Siff Gwyrdd o Chwith",
  "block.minecraft.banner.square_top_right.light_blue": "Canton Siff Glas Golau o Chwith",
  "block.minecraft.banner.square_top_right.light_gray": "Canton Siff Llwyd Golau o Chwith",
  "block.minecraft.banner.square_top_right.lime": "Canton Siff Leim o Chwith",
  "block.minecraft.banner.square_top_right.magenta": "Canton Siff Majenta o Chwith",
  "block.minecraft.banner.square_top_right.orange": "Canton Siff Oren o Chwith",
  "block.minecraft.banner.square_top_right.pink": "Canton Siff Pinc o Chwith",
  "block.minecraft.banner.square_top_right.purple": "Canton Siff Porffor o Chwith",
  "block.minecraft.banner.square_top_right.red": "Canton Siff Coch o Chwith",
  "block.minecraft.banner.square_top_right.white": "Canton Siff Gwyn o Chwith",
  "block.minecraft.banner.square_top_right.yellow": "Canton Siff Melyn o Chwith",
  "block.minecraft.banner.straight_cross.black": "Croes Ddu",
  "block.minecraft.banner.straight_cross.blue": "Croes Las",
  "block.minecraft.banner.straight_cross.brown": "Croes Frown",
  "block.minecraft.banner.straight_cross.cyan": "Croes Wyrddlas",
  "block.minecraft.banner.straight_cross.gray": "Croes Lwyd",
  "block.minecraft.banner.straight_cross.green": "Croes Wyrdd",
  "block.minecraft.banner.straight_cross.light_blue": "Croes Las Golau",
  "block.minecraft.banner.straight_cross.light_gray": "Croes Lwyd Golau",
  "block.minecraft.banner.straight_cross.lime": "Croes Leim",
  "block.minecraft.banner.straight_cross.magenta": "Croes Majenta",
  "block.minecraft.banner.straight_cross.orange": "Croes Oren",
  "block.minecraft.banner.straight_cross.pink": "Croes Binc",
  "block.minecraft.banner.straight_cross.purple": "Croes Porffor",
  "block.minecraft.banner.straight_cross.red": "Croes Goch",
  "block.minecraft.banner.straight_cross.white": "Croes Wyn",
  "block.minecraft.banner.straight_cross.yellow": "Croes Felyn",
  "block.minecraft.banner.stripe_bottom.black": "Sylfaen Du",
  "block.minecraft.banner.stripe_bottom.blue": "Sylfaen Glas",
  "block.minecraft.banner.stripe_bottom.brown": "Sylfaen Brown",
  "block.minecraft.banner.stripe_bottom.cyan": "Sylfaen Gwyrddlas",
  "block.minecraft.banner.stripe_bottom.gray": "Sylfaen Llwyd",
  "block.minecraft.banner.stripe_bottom.green": "Sylfaen Gwyrdd",
  "block.minecraft.banner.stripe_bottom.light_blue": "Sylfaen Glas Golau",
  "block.minecraft.banner.stripe_bottom.light_gray": "Sylfaen Llwyd Golau",
  "block.minecraft.banner.stripe_bottom.lime": "Sylfaen Leim",
  "block.minecraft.banner.stripe_bottom.magenta": "Sylfaen Majenta",
  "block.minecraft.banner.stripe_bottom.orange": "Sylfaen Oren",
  "block.minecraft.banner.stripe_bottom.pink": "Sylfaen Pinc",
  "block.minecraft.banner.stripe_bottom.purple": "Sylfaen Porffor",
  "block.minecraft.banner.stripe_bottom.red": "Sylfaen Coch",
  "block.minecraft.banner.stripe_bottom.white": "Sylfaen Gwyn",
  "block.minecraft.banner.stripe_bottom.yellow": "Sylfaen Felyn",
  "block.minecraft.banner.stripe_center.black": "Cledr Ddu",
  "block.minecraft.banner.stripe_center.blue": "Cledr Las",
  "block.minecraft.banner.stripe_center.brown": "Cledr Frown",
  "block.minecraft.banner.stripe_center.cyan": "Cledr Wyrddlas",
  "block.minecraft.banner.stripe_center.gray": "Cledr Lwyd",
  "block.minecraft.banner.stripe_center.green": "Cledr Wyrdd",
  "block.minecraft.banner.stripe_center.light_blue": "Cledr Las Golau",
  "block.minecraft.banner.stripe_center.light_gray": "Cledr Lwyd Golau",
  "block.minecraft.banner.stripe_center.lime": "Cledr Leim",
  "block.minecraft.banner.stripe_center.magenta": "Cledr Majenta",
  "block.minecraft.banner.stripe_center.orange": "Cledr Oren",
  "block.minecraft.banner.stripe_center.pink": "Cledr Binc",
  "block.minecraft.banner.stripe_center.purple": "Cledr Borffor",
  "block.minecraft.banner.stripe_center.red": "Cledr Goch",
  "block.minecraft.banner.stripe_center.white": "Cledr Wyn",
  "block.minecraft.banner.stripe_center.yellow": "Cledr Felyn",
  "block.minecraft.banner.stripe_downleft.black": "Rhwymyn Du Wrthdro",
  "block.minecraft.banner.stripe_downleft.blue": "Rhwymyn Glas Wrthdro",
  "block.minecraft.banner.stripe_downleft.brown": "Rhwymyn Brown Wrthdro",
  "block.minecraft.banner.stripe_downleft.cyan": "Rhwymyn Gwyrddlas Wrthdro",
  "block.minecraft.banner.stripe_downleft.gray": "Rhwymyn Llwyd Wrthdro",
  "block.minecraft.banner.stripe_downleft.green": "Rhwymyn Gwyrdd Wrthdro",
  "block.minecraft.banner.stripe_downleft.light_blue": "Rhwymyn Glas Golau Wrthdro",
  "block.minecraft.banner.stripe_downleft.light_gray": "Rhwymyn Llwyd Golau Wrthdro",
  "block.minecraft.banner.stripe_downleft.lime": "Rhwymyn Leim Wrthdro",
  "block.minecraft.banner.stripe_downleft.magenta": "Rhwymyn Majenta Wrthdro",
  "block.minecraft.banner.stripe_downleft.orange": "Rhwymyn Oren Wrthdro",
  "block.minecraft.banner.stripe_downleft.pink": "Rhwymyn Pinc Wrthdro",
  "block.minecraft.banner.stripe_downleft.purple": "Rhwymyn Porffor Wrthdro",
  "block.minecraft.banner.stripe_downleft.red": "Rhwymyn Coch Wrthdro",
  "block.minecraft.banner.stripe_downleft.white": "Rhwymyn Gwyn Wrthdro",
  "block.minecraft.banner.stripe_downleft.yellow": "Rhwymyn Melyn Wrthdro",
  "block.minecraft.banner.stripe_downright.black": "Rhwymyn Du",
  "block.minecraft.banner.stripe_downright.blue": "Rhwymyn Glas",
  "block.minecraft.banner.stripe_downright.brown": "Rhwymyn Brown",
  "block.minecraft.banner.stripe_downright.cyan": "Rhwymyn Gwyrddlas",
  "block.minecraft.banner.stripe_downright.gray": "Rhwymyn Llwyd",
  "block.minecraft.banner.stripe_downright.green": "Rhwymyn Gwyrdd",
  "block.minecraft.banner.stripe_downright.light_blue": "Rhwymyn Glas Golau",
  "block.minecraft.banner.stripe_downright.light_gray": "Rhwymyn Llwyd Golau",
  "block.minecraft.banner.stripe_downright.lime": "Rhwymyn Leim",
  "block.minecraft.banner.stripe_downright.magenta": "Rhwymyn Majenta",
  "block.minecraft.banner.stripe_downright.orange": "Rhwymyn Oren",
  "block.minecraft.banner.stripe_downright.pink": "Rhwymyn Pinc",
  "block.minecraft.banner.stripe_downright.purple": "Rhwymyn Porffor",
  "block.minecraft.banner.stripe_downright.red": "Rhwymyn Coch",
  "block.minecraft.banner.stripe_downright.white": "Rhwymyn Gwyn",
  "block.minecraft.banner.stripe_downright.yellow": "Rhwymyn Melyn",
  "block.minecraft.banner.stripe_left.black": "Cledr Ddu Ddehau",
  "block.minecraft.banner.stripe_left.blue": "Cledr Las Ddehau",
  "block.minecraft.banner.stripe_left.brown": "Cledr Frown Ddehau",
  "block.minecraft.banner.stripe_left.cyan": "Cledr Wyrddlas Ddehau",
  "block.minecraft.banner.stripe_left.gray": "Cledr Lwyd Ddehau",
  "block.minecraft.banner.stripe_left.green": "Cledr Wyrdd Ddehau",
  "block.minecraft.banner.stripe_left.light_blue": "Cledr Las Golau Ddehau",
  "block.minecraft.banner.stripe_left.light_gray": "Cledr Lwyd Golau Ddehau",
  "block.minecraft.banner.stripe_left.lime": "Cledr Leim Ddehau",
  "block.minecraft.banner.stripe_left.magenta": "Cledr Majenta Ddehau",
  "block.minecraft.banner.stripe_left.orange": "Cledr Oren Ddehau",
  "block.minecraft.banner.stripe_left.pink": "Cledr Binc Ddehau",
  "block.minecraft.banner.stripe_left.purple": "Cledr Borffor Ddehau",
  "block.minecraft.banner.stripe_left.red": "Cledr Goch Ddehau",
  "block.minecraft.banner.stripe_left.white": "Cledr Wyn Ddehau",
  "block.minecraft.banner.stripe_left.yellow": "Cledr Felyn Ddehau",
  "block.minecraft.banner.stripe_middle.black": "Bar Du",
  "block.minecraft.banner.stripe_middle.blue": "Bar Glas",
  "block.minecraft.banner.stripe_middle.brown": "Bar Brown",
  "block.minecraft.banner.stripe_middle.cyan": "Bar Gwyrddlas",
  "block.minecraft.banner.stripe_middle.gray": "Bar Llwyd",
  "block.minecraft.banner.stripe_middle.green": "Bar Gwyrdd",
  "block.minecraft.banner.stripe_middle.light_blue": "Bar Glas Golau",
  "block.minecraft.banner.stripe_middle.light_gray": "Bar Llwyd Golau",
  "block.minecraft.banner.stripe_middle.lime": "Bar Leim",
  "block.minecraft.banner.stripe_middle.magenta": "Bar Majenta",
  "block.minecraft.banner.stripe_middle.orange": "Bar Oren",
  "block.minecraft.banner.stripe_middle.pink": "Bar Pinc",
  "block.minecraft.banner.stripe_middle.purple": "Bar Porffor",
  "block.minecraft.banner.stripe_middle.red": "Bar Coch",
  "block.minecraft.banner.stripe_middle.white": "Bar Gwyn",
  "block.minecraft.banner.stripe_middle.yellow": "Bar Melyn",
  "block.minecraft.banner.stripe_right.black": "Cledr Ddu o Chwith",
  "block.minecraft.banner.stripe_right.blue": "Cledr Las o Chwith",
  "block.minecraft.banner.stripe_right.brown": "Cledr Frown o Chwith",
  "block.minecraft.banner.stripe_right.cyan": "Cledr Wyrddlas o Chwith",
  "block.minecraft.banner.stripe_right.gray": "Cledr Lwyd o Chwith",
  "block.minecraft.banner.stripe_right.green": "Cledr Wyrdd o Chwith",
  "block.minecraft.banner.stripe_right.light_blue": "Cledr Glas Golau o Chwith",
  "block.minecraft.banner.stripe_right.light_gray": "Cledr Lwyd Golau o Chwith",
  "block.minecraft.banner.stripe_right.lime": "Cledr Leim o Chwith",
  "block.minecraft.banner.stripe_right.magenta": "Pâl Majenta o Chwith",
  "block.minecraft.banner.stripe_right.orange": "Cledr Oren o Chwith",
  "block.minecraft.banner.stripe_right.pink": "Cledr Binc o Chwith",
  "block.minecraft.banner.stripe_right.purple": "Cledr Borffor o Chwith",
  "block.minecraft.banner.stripe_right.red": "Cledr Goch o Chwith",
  "block.minecraft.banner.stripe_right.white": "Cledr Wyn o Chwith",
  "block.minecraft.banner.stripe_right.yellow": "Cledr Felyn o Chwith",
  "block.minecraft.banner.stripe_top.black": "Siff Du",
  "block.minecraft.banner.stripe_top.blue": "Siff Glas",
  "block.minecraft.banner.stripe_top.brown": "Siff Brown",
  "block.minecraft.banner.stripe_top.cyan": "Siff Gwyrddlas",
  "block.minecraft.banner.stripe_top.gray": "Siff Llwyd",
  "block.minecraft.banner.stripe_top.green": "Siff Gwyrdd",
  "block.minecraft.banner.stripe_top.light_blue": "Siff Glas Golau",
  "block.minecraft.banner.stripe_top.light_gray": "Siff Llwyd Golau",
  "block.minecraft.banner.stripe_top.lime": "Siff Leim",
  "block.minecraft.banner.stripe_top.magenta": "Siff Majenta",
  "block.minecraft.banner.stripe_top.orange": "Siff Oren",
  "block.minecraft.banner.stripe_top.pink": "Siff Pinc",
  "block.minecraft.banner.stripe_top.purple": "Siff Porffor",
  "block.minecraft.banner.stripe_top.red": "Siff Coch",
  "block.minecraft.banner.stripe_top.white": "Siff Gwyn",
  "block.minecraft.banner.stripe_top.yellow": "Siff Melyn",
  "block.minecraft.banner.triangle_bottom.black": "Sieffrwn Du",
  "block.minecraft.banner.triangle_bottom.blue": "Sieffrwn Glas",
  "block.minecraft.banner.triangle_bottom.brown": "Sieffrwn Brown",
  "block.minecraft.banner.triangle_bottom.cyan": "Sieffrwn Gwyrddlas",
  "block.minecraft.banner.triangle_bottom.gray": "Sieffrwn Llwyd",
  "block.minecraft.banner.triangle_bottom.green": "Sieffrwn Gwyrdd",
  "block.minecraft.banner.triangle_bottom.light_blue": "Sieffrwn Glas Golau",
  "block.minecraft.banner.triangle_bottom.light_gray": "Sieffrwn Llwyd Golau",
  "block.minecraft.banner.triangle_bottom.lime": "Sieffrwn Leim",
  "block.minecraft.banner.triangle_bottom.magenta": "Sieffrwn Majenta",
  "block.minecraft.banner.triangle_bottom.orange": "Sieffrwn Oren",
  "block.minecraft.banner.triangle_bottom.pink": "Sieffrwn Pinc",
  "block.minecraft.banner.triangle_bottom.purple": "Sieffrwn Porffor",
  "block.minecraft.banner.triangle_bottom.red": "Sieffrwn Coch",
  "block.minecraft.banner.triangle_bottom.white": "Sieffrwn Gwyn",
  "block.minecraft.banner.triangle_bottom.yellow": "Sieffrwn Melyn",
  "block.minecraft.banner.triangle_top.black": "Sieffrwn Du Gwrthdro",
  "block.minecraft.banner.triangle_top.blue": "Sieffrwn Glas Gwrthdro",
  "block.minecraft.banner.triangle_top.brown": "Sieffrwn Brown Gwrthdro",
  "block.minecraft.banner.triangle_top.cyan": "Sieffrwn Gwyrddlas Gwrthdro",
  "block.minecraft.banner.triangle_top.gray": "Sieffrwn Llwyd Gwrthdro",
  "block.minecraft.banner.triangle_top.green": "Sieffrwn Gwyrdd Gwrthdro",
  "block.minecraft.banner.triangle_top.light_blue": "Sieffrwn Glas Golau Gwrthdro",
  "block.minecraft.banner.triangle_top.light_gray": "Sieffrwn Llwyd Golau Gwrthdro",
  "block.minecraft.banner.triangle_top.lime": "Sieffrwn Leim Gwrthdro",
  "block.minecraft.banner.triangle_top.magenta": "Sieffrwn Majenta Gwrthdro",
  "block.minecraft.banner.triangle_top.orange": "Sieffrwn Oren Gwrthdro",
  "block.minecraft.banner.triangle_top.pink": "Sieffrwn Pinc Gwrthdro",
  "block.minecraft.banner.triangle_top.purple": "Sieffrwn Porffor Gwrthdro",
  "block.minecraft.banner.triangle_top.red": "Sieffrwn Coch Gwrthdro",
  "block.minecraft.banner.triangle_top.white": "Sieffrwn Gwyn Gwrthdro",
  "block.minecraft.banner.triangle_top.yellow": "Sieffrwn Melyn Gwrthdro",
  "block.minecraft.banner.triangles_bottom.black": "Sail Rasyd Du",
  "block.minecraft.banner.triangles_bottom.blue": "Sail Rasyd Glas",
  "block.minecraft.banner.triangles_bottom.brown": "Sail Rasyd Brown",
  "block.minecraft.banner.triangles_bottom.cyan": "Sail Rasyd Gwyrddlas",
  "block.minecraft.banner.triangles_bottom.gray": "Sail Rasyd Llwyd",
  "block.minecraft.banner.triangles_bottom.green": "Sail Rasyd Gwyrdd",
  "block.minecraft.banner.triangles_bottom.light_blue": "Sail Rasyd Glas Golau",
  "block.minecraft.banner.triangles_bottom.light_gray": "Sail Rasyd Llwyd Golau",
  "block.minecraft.banner.triangles_bottom.lime": "Sail Rasyd Leim",
  "block.minecraft.banner.triangles_bottom.magenta": "Sail Rasyd Majenta",
  "block.minecraft.banner.triangles_bottom.orange": "Sail Rasyd Oren",
  "block.minecraft.banner.triangles_bottom.pink": "Sail Rasyd Pinc",
  "block.minecraft.banner.triangles_bottom.purple": "Sail Rasyd Porffor",
  "block.minecraft.banner.triangles_bottom.red": "Sail Rasyd Coch",
  "block.minecraft.banner.triangles_bottom.white": "Sail Rasyd Gwyn",
  "block.minecraft.banner.triangles_bottom.yellow": "Sail Rasyd Melyn",
  "block.minecraft.banner.triangles_top.black": "Siff Rasyd Du",
  "block.minecraft.banner.triangles_top.blue": "Siff Rasyd Glas",
  "block.minecraft.banner.triangles_top.brown": "Siff Rasyd Brown",
  "block.minecraft.banner.triangles_top.cyan": "Siff Rasyd Gwyrddlas",
  "block.minecraft.banner.triangles_top.gray": "Siff Rasyd Llwyd",
  "block.minecraft.banner.triangles_top.green": "Siff Rasyd Gwyrdd",
  "block.minecraft.banner.triangles_top.light_blue": "Siff Rasyd Glas Golau",
  "block.minecraft.banner.triangles_top.light_gray": "Siff Rasyd Llwyd Golau",
  "block.minecraft.banner.triangles_top.lime": "Siff Rasyd Leim",
  "block.minecraft.banner.triangles_top.magenta": "Siff Rasyd Majenta",
  "block.minecraft.banner.triangles_top.orange": "Siff Rasyd Oren",
  "block.minecraft.banner.triangles_top.pink": "Siff Rasyd Pinc",
  "block.minecraft.banner.triangles_top.purple": "Siff Rasyd Porffor",
  "block.minecraft.banner.triangles_top.red": "Siff Rasyd Coch",
  "block.minecraft.banner.triangles_top.white": "Siff Rasyd Gwyn",
  "block.minecraft.banner.triangles_top.yellow": "Siff Rasyd Melyn",
  "block.minecraft.barrel": "Casgen",
  "block.minecraft.barrier": "Rhwystr",
  "block.minecraft.basalt": "Pilergraig",
  "block.minecraft.beacon": "Goleufa",
  "block.minecraft.beacon.primary": "Pŵer Cynradd",
  "block.minecraft.beacon.secondary": "Pŵer Eilaidd",
  "block.minecraft.bed.no_sleep": "Gallwch ond gysgu gyda'r nos neu yn ystod storm",
  "block.minecraft.bed.not_safe": "Ni allwch gysgu nawr, mae bwystfilod sy'n agos",
  "block.minecraft.bed.obstructed": "Mae'r gwely hwn wedi'i rhwystro",
  "block.minecraft.bed.occupied": "Mae'r gwely yma wedi meddiannu",
  "block.minecraft.bed.too_far_away": "Ni allwch gysgu nawr, mae'r gwely'n rhy bell",
  "block.minecraft.bedrock": "Creigwely",
  "block.minecraft.bee_nest": "Nyth Gwenyn",
  "block.minecraft.beehive": "Cwch Gwenyn",
  "block.minecraft.beetroots": "Betys",
  "block.minecraft.bell": "Cloch",
  "block.minecraft.big_dripleaf": "Diferddeilen Fawr",
  "block.minecraft.big_dripleaf_stem": "Coesyn Diferddeilen Fawr",
  "block.minecraft.birch_button": "Botwm Bedw",
  "block.minecraft.birch_door": "Drws Bedw",
  "block.minecraft.birch_fence": "Ffens Fedw",
  "block.minecraft.birch_fence_gate": "Gât Ffens Fedw",
  "block.minecraft.birch_hanging_sign": "Arwydd Crog Bedw",
  "block.minecraft.birch_leaves": "Dail Bedw",
  "block.minecraft.birch_log": "Boncyff Bedw",
  "block.minecraft.birch_planks": "Planciau Bedw",
  "block.minecraft.birch_pressure_plate": "Gwasglechen Bedw",
  "block.minecraft.birch_sapling": "Glasbren Bedw",
  "block.minecraft.birch_shelf": "Silff Bedw",
  "block.minecraft.birch_sign": "Arwydd Bedw",
  "block.minecraft.birch_slab": "Slab Bedw",
  "block.minecraft.birch_stairs": "Grisiau Bedw",
  "block.minecraft.birch_trapdoor": "Drws Cudd Fedwen",
  "block.minecraft.birch_wall_hanging_sign": "Arwydd Wal Crog Bedw",
  "block.minecraft.birch_wall_sign": "Arwydd Wal Bedw",
  "block.minecraft.birch_wood": "Pren Bedw",
  "block.minecraft.black_banner": "Baner Ddu",
  "block.minecraft.black_bed": "Gwely Du",
  "block.minecraft.black_candle": "Canwyll Ddu",
  "block.minecraft.black_candle_cake": "Teisen â Channwyll Du",
  "block.minecraft.black_carpet": "Carped Du",
  "block.minecraft.black_concrete": "Concrit Du",
  "block.minecraft.black_concrete_powder": "Powdr Concrit Du",
  "block.minecraft.black_glazed_terracotta": "Terracotta Du Gwydrog",
  "block.minecraft.black_shulker_box": "Blwch Shulker Du",
  "block.minecraft.black_stained_glass": "Gwydr Lliw Du",
  "block.minecraft.black_stained_glass_pane": "Paen Gwydr Lliw Du",
  "block.minecraft.black_terracotta": "Terracotta Du",
  "block.minecraft.black_wool": "Gwlân Du",
  "block.minecraft.blackstone": "Carregddu",
  "block.minecraft.blackstone_slab": "Slab Carregddu",
  "block.minecraft.blackstone_stairs": "Grisiau Carregddu",
  "block.minecraft.blackstone_wall": "Wal Garregddu",
  "block.minecraft.blast_furnace": "Ffwrnais Chwyth",
  "block.minecraft.blue_banner": "Baner Las",
  "block.minecraft.blue_bed": "Gwely Glas",
  "block.minecraft.blue_candle": "Canwyll Las",
  "block.minecraft.blue_candle_cake": "Teisen â Channwyll Glas",
  "block.minecraft.blue_carpet": "Carped Glas",
  "block.minecraft.blue_concrete": "Concrit Glas",
  "block.minecraft.blue_concrete_powder": "Powdr Concrit Glas",
  "block.minecraft.blue_glazed_terracotta": "Terracotta Glas Gwydrog",
  "block.minecraft.blue_ice": "Rhew Glas",
  "block.minecraft.blue_orchid": "Tegeirian Glas",
  "block.minecraft.blue_shulker_box": "Blwch Shulker Glas",
  "block.minecraft.blue_stained_glass": "Gwydr Lliw Glas",
  "block.minecraft.blue_stained_glass_pane": "Paen Gwydr Lliw Glas",
  "block.minecraft.blue_terracotta": "Terracotta Glas",
  "block.minecraft.blue_wool": "Gwlân Glas",
  "block.minecraft.bone_block": "Bloc Asgwrn",
  "block.minecraft.bookshelf": "Silff Lyfrau",
  "block.minecraft.brain_coral": "Cwrel Ymennydd",
  "block.minecraft.brain_coral_block": "Bloc Cwrel Ymenydd",
  "block.minecraft.brain_coral_fan": "Ffan Cwrel Ymenydd",
  "block.minecraft.brain_coral_wall_fan": "Ffan Wal Cwrel Ymennydd",
  "block.minecraft.brewing_stand": "Safle Bragu",
  "block.minecraft.brick_slab": "Slab Bricsen",
  "block.minecraft.brick_stairs": "Grisiau Bricsen",
  "block.minecraft.brick_wall": "Wal Friciau",
  "block.minecraft.bricks": "Briciau",
  "block.minecraft.brown_banner": "Baner Frown",
  "block.minecraft.brown_bed": "Gwely Brown",
  "block.minecraft.brown_candle": "Canwyll Frown",
  "block.minecraft.brown_candle_cake": "Teisen â Channwyll Brown",
  "block.minecraft.brown_carpet": "Carped Brown",
  "block.minecraft.brown_concrete": "Concrit Brown",
  "block.minecraft.brown_concrete_powder": "Powdr Concrit Brown",
  "block.minecraft.brown_glazed_terracotta": "Terracotta Brown Gwydrog",
  "block.minecraft.brown_mushroom": "Madarchen Frown",
  "block.minecraft.brown_mushroom_block": "Bloc Madarch Brown",
  "block.minecraft.brown_shulker_box": "Blwch Shulker Brown",
  "block.minecraft.brown_stained_glass": "Gwydr Lliw Brown",
  "block.minecraft.brown_stained_glass_pane": "Paen Gwydr Lliw Brown",
  "block.minecraft.brown_terracotta": "Terracotta Brown",
  "block.minecraft.brown_wool": "Gwlân Brown",
  "block.minecraft.bubble_column": "Colofn Swigod",
  "block.minecraft.bubble_coral": "Cwrel Brith",
  "block.minecraft.bubble_coral_block": "Bloc Cwrel Brith",
  "block.minecraft.bubble_coral_fan": "Ffan Cwrel Brith",
  "block.minecraft.bubble_coral_wall_fan": "Ffan Wal Gwrel Brith",
  "block.minecraft.budding_amethyst": "Amethyst Blagurol",
  "block.minecraft.bush": "Llwyn",
  "block.minecraft.cactus": "Cactws",
  "block.minecraft.cactus_flower": "Blodyn Cactws",
  "block.minecraft.cake": "Teisen",
  "block.minecraft.calcite": "Calsit",
  "block.minecraft.calibrated_sculk_sensor": "Synhwyrydd Sculk Wedi Graddnodi",
  "block.minecraft.campfire": "Tân Gwersyll",
  "block.minecraft.candle": "Canwyll",
  "block.minecraft.candle_cake": "Teisien â Channwyll",
  "block.minecraft.carrots": "Moron",
  "block.minecraft.cartography_table": "Bwrdd Cartograffeg",
  "block.minecraft.carved_pumpkin": "Pwmpen Gerfiedig",
  "block.minecraft.cauldron": "Crochan",
  "block.minecraft.cave_air": "Aer Ogof",
  "block.minecraft.cave_vines": "Gwinwydd Ogof",
  "block.minecraft.cave_vines_plant": "Planhigyn Gwinwydd Ogof",
  "block.minecraft.chain": "Cadwyn",
  "block.minecraft.chain_command_block": "Bloc Gorchymyn Cadwynol",
  "block.minecraft.cherry_button": "Botwm Ceirios",
  "block.minecraft.cherry_door": "Drws Ceirios",
  "block.minecraft.cherry_fence": "Ffens Geirios",
  "block.minecraft.cherry_fence_gate": "Gât Ffens Geirios",
  "block.minecraft.cherry_hanging_sign": "Arwydd Crog Ceirios",
  "block.minecraft.cherry_leaves": "Dail Ceirios",
  "block.minecraft.cherry_log": "Boncyff Ceirios",
  "block.minecraft.cherry_planks": "Planciau Ceirios",
  "block.minecraft.cherry_pressure_plate": "Gwasglechen Ceirios",
  "block.minecraft.cherry_sapling": "Glasbren Ceirios",
  "block.minecraft.cherry_shelf": "Silff Ceirios",
  "block.minecraft.cherry_sign": "Arwydd Ceirios",
  "block.minecraft.cherry_slab": "Slab Ceirios",
  "block.minecraft.cherry_stairs": "Grisiau Ceirios",
  "block.minecraft.cherry_trapdoor": "Drws Cudd Ceirios",
  "block.minecraft.cherry_wall_hanging_sign": "Arwydd Wal Crog Ceirios",
  "block.minecraft.cherry_wall_sign": "Arwydd Wal Ceirios",
  "block.minecraft.cherry_wood": "Pren Ceirios",
  "block.minecraft.chest": "Cist",
  "block.minecraft.chipped_anvil": "Einion Dolciog",
  "block.minecraft.chiseled_bookshelf": "Silff Lyfrau Nadd",
  "block.minecraft.chiseled_copper": "Copr Nadd",
  "block.minecraft.chiseled_deepslate": "Dwfnlech Nadd",
  "block.minecraft.chiseled_nether_bricks": "Briciau Nether Nadd",
  "block.minecraft.chiseled_polished_blackstone": "Carregddu Caboledig Nadd",
  "block.minecraft.chiseled_quartz_block": "Bloc Cwarts Nadd",
  "block.minecraft.chiseled_red_sandstone": "Tywodfaen Nadd Coch",
  "block.minecraft.chiseled_resin_bricks": "Briciau Resin Nadd",
  "block.minecraft.chiseled_sandstone": "Tywodfaen Nadd",
  "block.minecraft.chiseled_stone_bricks": "Briciau Carreg Nadd",
  "block.minecraft.chiseled_tuff": "Twff Nadd",
  "block.minecraft.chiseled_tuff_bricks": "Briciau Twff Nadd",
  "block.minecraft.chorus_flower": "Blodyn Corws",
  "block.minecraft.chorus_plant": "Planhigyn Corws",
  "block.minecraft.clay": "Clai",
  "block.minecraft.closed_eyeblossom": "Llygadflodyn Cau",
  "block.minecraft.coal_block": "Bloc Glo",
  "block.minecraft.coal_ore": "Mwyn Glo",
  "block.minecraft.coarse_dirt": "Pridd Garw",
  "block.minecraft.cobbled_deepslate": "Dwfnlech Coblog",
  "block.minecraft.cobbled_deepslate_slab": "Slab Dwfnlech Coblog",
  "block.minecraft.cobbled_deepslate_stairs": "Grisiau Dwfnlech Coblog",
  "block.minecraft.cobbled_deepslate_wall": "Wal Ddwfnlech Coblog",
  "block.minecraft.cobblestone": "Crynion",
  "block.minecraft.cobblestone_slab": "Slab Crynion",
  "block.minecraft.cobblestone_stairs": "Grisiau Crynion",
  "block.minecraft.cobblestone_wall": "Wal Crynion",
  "block.minecraft.cobweb": "Gwe Pricopyn",
  "block.minecraft.cocoa": "Coco",
  "block.minecraft.command_block": "Bloc Gorchymyn",
  "block.minecraft.comparator": "Cymharydd Redstone",
  "block.minecraft.composter": "Compostiwr",
  "block.minecraft.conduit": "Cwndid",
  "block.minecraft.copper_bars": "Bariau Copr",
  "block.minecraft.copper_block": "Bloc Copr",
  "block.minecraft.copper_bulb": "Bwlb Copr",
  "block.minecraft.copper_chain": "Cadwyn Copr",
  "block.minecraft.copper_chest": "Cist Copr",
  "block.minecraft.copper_door": "Drws Copr",
  "block.minecraft.copper_golem_statue": "Cerflun Golem Copr",
  "block.minecraft.copper_grate": "Gratiau Copr",
  "block.minecraft.copper_lantern": "Llusern Copr",
  "block.minecraft.copper_ore": "Mwyn Copr",
  "block.minecraft.copper_torch": "Tors Copr",
  "block.minecraft.copper_trapdoor": "Drws Cudd Copr",
  "block.minecraft.copper_wall_torch": "Tors Wal Copr",
  "block.minecraft.cornflower": "Penlas Wen",
  "block.minecraft.cracked_deepslate_bricks": "Briciau Dwfnlech Chwâl",
  "block.minecraft.cracked_deepslate_tiles": "Teils Dwfnlech Chwâl",
  "block.minecraft.cracked_nether_bricks": "Briciau Nether Chwâl",
  "block.minecraft.cracked_polished_blackstone_bricks": "Briciau Carregddu Caboledig Chwâl",
  "block.minecraft.cracked_stone_bricks": "Briciau Carreg Chwâl",
  "block.minecraft.crafter": "Crefftiwr",
  "block.minecraft.crafting_table": "Bwrdd Crefft",
  "block.minecraft.creaking_heart": "Calon Gwich",
  "block.minecraft.creeper_head": "Pen Creeper",
  "block.minecraft.creeper_wall_head": "Pen Wal Creeper",
  "block.minecraft.crimson_button": "Botwm Rhuddgoch",
  "block.minecraft.crimson_door": "Drws Rhuddgoch",
  "block.minecraft.crimson_fence": "Ffens Ruddgoch",
  "block.minecraft.crimson_fence_gate": "Gât Ffens Ruddgoch",
  "block.minecraft.crimson_fungus": "Ffwng Rhuddgoch",
  "block.minecraft.crimson_hanging_sign": "Arwydd Crog Rhuddgoch",
  "block.minecraft.crimson_hyphae": "Hyffae Rhuddgoch",
  "block.minecraft.crimson_nylium": "Neliwm Rhuddgoch",
  "block.minecraft.crimson_planks": "Planciau Rhuddgoch",
  "block.minecraft.crimson_pressure_plate": "Gwasglechen Rhuddgoch",
  "block.minecraft.crimson_roots": "Gwreiddiau Rhuddgoch",
  "block.minecraft.crimson_shelf": "Silff Rhuddgoch",
  "block.minecraft.crimson_sign": "Arwydd Rhuddgoch",
  "block.minecraft.crimson_slab": "Slab Rhuddgoch",
  "block.minecraft.crimson_stairs": "Grisiau Rhuddgoch",
  "block.minecraft.crimson_stem": "Coesyn Rhuddgoch",
  "block.minecraft.crimson_trapdoor": "Drws Cudd Rhuddgoch",
  "block.minecraft.crimson_wall_hanging_sign": "Arwydd Wal Crog Rhuddgoch",
  "block.minecraft.crimson_wall_sign": "Arwydd Wal Rhuddgoch",
  "block.minecraft.crying_obsidian": "Wylolosgraig",
  "block.minecraft.cut_copper": "Copr Toredig",
  "block.minecraft.cut_copper_slab": "Slab Copr Toredig",
  "block.minecraft.cut_copper_stairs": "Grisiau Copr Toredig",
  "block.minecraft.cut_red_sandstone": "Tywodfaen Coch Toredig",
  "block.minecraft.cut_red_sandstone_slab": "Slab Tywodfaen Coch Toredig",
  "block.minecraft.cut_sandstone": "Tywodfaen Toredig",
  "block.minecraft.cut_sandstone_slab": "Slab Tywodfaen Toredig",
  "block.minecraft.cyan_banner": "Baner Wyrddlas",
  "block.minecraft.cyan_bed": "Gwely Gwyrddlas",
  "block.minecraft.cyan_candle": "Canwyll Wyrddlas",
  "block.minecraft.cyan_candle_cake": "Teisen â Channwyll Gwyrddlas",
  "block.minecraft.cyan_carpet": "Carped Gwyrddlas",
  "block.minecraft.cyan_concrete": "Concrit Gwyrddlas",
  "block.minecraft.cyan_concrete_powder": "Powdr Concrit Gwyrddlas",
  "block.minecraft.cyan_glazed_terracotta": "Terracotta Gwyrddlas Gwydrog",
  "block.minecraft.cyan_shulker_box": "Blwch Shulker Gwyrddlas",
  "block.minecraft.cyan_stained_glass": "Gwydr Lliw Gwyrddlas",
  "block.minecraft.cyan_stained_glass_pane": "Paen Gwydr Lliw Gwyrddlas",
  "block.minecraft.cyan_terracotta": "Terracotta Gwyrddlas",
  "block.minecraft.cyan_wool": "Gwlân Gwyrddlas",
  "block.minecraft.damaged_anvil": "Einion wedi'i Ddifrodi",
  "block.minecraft.dandelion": "Dant y Llew",
  "block.minecraft.dark_oak_button": "Botwm Derw Tywyll",
  "block.minecraft.dark_oak_door": "Drws Derw Tywyll",
  "block.minecraft.dark_oak_fence": "Ffens Dderw Tywyll",
  "block.minecraft.dark_oak_fence_gate": "Gât Ffens Dderw Dywyll",
  "block.minecraft.dark_oak_hanging_sign": "Arwydd Crog Derw Tywyll",
  "block.minecraft.dark_oak_leaves": "Dail Derw Tywyll",
  "block.minecraft.dark_oak_log": "Boncyff Derw Tywyll",
  "block.minecraft.dark_oak_planks": "Planciau Derw Tywyll",
  "block.minecraft.dark_oak_pressure_plate": "Gwasglechen Derw Tywyll",
  "block.minecraft.dark_oak_sapling": "Glasbren Derw Tywyll",
  "block.minecraft.dark_oak_shelf": "Silff Derw Tywyll",
  "block.minecraft.dark_oak_sign": "Arwydd Derw Tywyll",
  "block.minecraft.dark_oak_slab": "Slab Derw Tywyll",
  "block.minecraft.dark_oak_stairs": "Grisiau Derw Tywyll",
  "block.minecraft.dark_oak_trapdoor": "Drws Cudd Derw Tywyll",
  "block.minecraft.dark_oak_wall_hanging_sign": "Arwydd Wal Crog Derw Tywyll",
  "block.minecraft.dark_oak_wall_sign": "Arwydd Wal Derw Tywyll",
  "block.minecraft.dark_oak_wood": "Pren Derw Tywyll",
  "block.minecraft.dark_prismarine": "Prismarin Tywyll",
  "block.minecraft.dark_prismarine_slab": "Slab Prismarin Tywyll",
  "block.minecraft.dark_prismarine_stairs": "Grisiau Prismarin Tywyll",
  "block.minecraft.daylight_detector": "Synhwyrydd Golau Dydd",
  "block.minecraft.dead_brain_coral": "Cwrel Ymenydd Wedi Marw",
  "block.minecraft.dead_brain_coral_block": "Bloc Cwrel Ymennydd Wedi Marw",
  "block.minecraft.dead_brain_coral_fan": "Ffan Cwrel Ymennydd Wedi Marw",
  "block.minecraft.dead_brain_coral_wall_fan": "Ffan Wal Cwrel Ymennydd Wedi Marw",
  "block.minecraft.dead_bubble_coral": "Cwrel Brith Marw",
  "block.minecraft.dead_bubble_coral_block": "Bloc Cwrel Brith Marw",
  "block.minecraft.dead_bubble_coral_fan": "Ffan Gwrel Brith Marw",
  "block.minecraft.dead_bubble_coral_wall_fan": "Ffan Wal Gwrel Brith Marw",
  "block.minecraft.dead_bush": "Llwyn Marw",
  "block.minecraft.dead_fire_coral": "Cwrel Tân Marw",
  "block.minecraft.dead_fire_coral_block": "Bloc Cwrel Tân Marw",
  "block.minecraft.dead_fire_coral_fan": "Ffan Gwrel Tân Marw",
  "block.minecraft.dead_fire_coral_wall_fan": "Ffan Wal Gwrel Tân Marw",
  "block.minecraft.dead_horn_coral": "Cwrel Corn Marw",
  "block.minecraft.dead_horn_coral_block": "Bloc Cwrel Corn Marw",
  "block.minecraft.dead_horn_coral_fan": "Ffan Gwrel Corn Marw",
  "block.minecraft.dead_horn_coral_wall_fan": "Ffan Wal Gwrel Corn Marw",
  "block.minecraft.dead_tube_coral": "Cwrel Piben Marw",
  "block.minecraft.dead_tube_coral_block": "Bloc Cwrel Piben Marw",
  "block.minecraft.dead_tube_coral_fan": "Ffan Gwrel Piben Marw",
  "block.minecraft.dead_tube_coral_wall_fan": "Ffan Wal Gwrel Piben Marw",
  "block.minecraft.decorated_pot": "Pot Addurnedig",
  "block.minecraft.deepslate": "Dwfnlech",
  "block.minecraft.deepslate_brick_slab": "Slab Bricsen Dwfnlech",
  "block.minecraft.deepslate_brick_stairs": "Grisiau Bricsen Dwfnlech",
  "block.minecraft.deepslate_brick_wall": "Wal Friciau Dwfnlech",
  "block.minecraft.deepslate_bricks": "Briciau Dwfnlech",
  "block.minecraft.deepslate_coal_ore": "Mwyn Glo Dwfnlech",
  "block.minecraft.deepslate_copper_ore": "Mwyn Copr Dwfnlech",
  "block.minecraft.deepslate_diamond_ore": "Mwyn Diemwnt Dwfnlech",
  "block.minecraft.deepslate_emerald_ore": "Mwyn Emrallt Dwfnlech",
  "block.minecraft.deepslate_gold_ore": "Mwyn Aur Dwfnlech",
  "block.minecraft.deepslate_iron_ore": "Mwyn Haearn Dwfnlech",
  "block.minecraft.deepslate_lapis_ore": "Mwyn Lapis-Laswli Dwfnlech",
  "block.minecraft.deepslate_redstone_ore": "Mwyn Redstone Dwfnlech",
  "block.minecraft.deepslate_tile_slab": "Slab Teils Dwfnlech",
  "block.minecraft.deepslate_tile_stairs": "Grisiau Teils Dwfnlech",
  "block.minecraft.deepslate_tile_wall": "Wal Teils Dwfnlech",
  "block.minecraft.deepslate_tiles": "Teils Dwfnlech",
  "block.minecraft.detector_rail": "Cledren Synhwyrydd",
  "block.minecraft.diamond_block": "Bloc Diemwnt",
  "block.minecraft.diamond_ore": "Mwyn Diemwnt",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Slab Diorit",
  "block.minecraft.diorite_stairs": "Grisiau Diorit",
  "block.minecraft.diorite_wall": "Wal Diorit",
  "block.minecraft.dirt": "Pridd",
  "block.minecraft.dirt_path": "Llwybr Lludw",
  "block.minecraft.dispenser": "Dosbarthwr",
  "block.minecraft.dragon_egg": "Ŵy Ddraig",
  "block.minecraft.dragon_head": "Pen Draig",
  "block.minecraft.dragon_wall_head": "Pen Wal Draig",
  "block.minecraft.dried_ghast": "Ghast Sych",
  "block.minecraft.dried_kelp_block": "Bloc Gwymon Sych",
  "block.minecraft.dripstone_block": "Bloc Diferfaen",
  "block.minecraft.dropper": "Gollyngwr",
  "block.minecraft.emerald_block": "Bloc Emrallt",
  "block.minecraft.emerald_ore": "Mwyn Emrallt",
  "block.minecraft.enchanting_table": "Bwrdd Hudoliaethu",
  "block.minecraft.end_gateway": "Porth End",
  "block.minecraft.end_portal": "Porth End",
  "block.minecraft.end_portal_frame": "Ffrâm Borth End",
  "block.minecraft.end_rod": "Gwialen End",
  "block.minecraft.end_stone": "Carreg End",
  "block.minecraft.end_stone_brick_slab": "Slab Bricsen Carreg End",
  "block.minecraft.end_stone_brick_stairs": "Grisiau Bricsen Carreg End",
  "block.minecraft.end_stone_brick_wall": "Wal Friciau Carreg End",
  "block.minecraft.end_stone_bricks": "Briciau Carreg End",
  "block.minecraft.ender_chest": "Cist Ender",
  "block.minecraft.exposed_chiseled_copper": "Copr Nadd Wedi Pylu",
  "block.minecraft.exposed_copper": "Copr Wedi Pylu",
  "block.minecraft.exposed_copper_bars": "Bariau Copr Wedi Pylu",
  "block.minecraft.exposed_copper_bulb": "Bwlb Copr Wedi Pylu",
  "block.minecraft.exposed_copper_chain": "Cadwyn Copr Wedi Pylu",
  "block.minecraft.exposed_copper_chest": "Cist Copr Wedi Pylu",
  "block.minecraft.exposed_copper_door": "Drws Copr Wedi Pylu",
  "block.minecraft.exposed_copper_golem_statue": "Cerflun Golem Copr Wedi Pylu",
  "block.minecraft.exposed_copper_grate": "Gratiau Copr Wedi Pylu",
  "block.minecraft.exposed_copper_lantern": "Llusern Copr Wedi Pylu",
  "block.minecraft.exposed_copper_trapdoor": "Drws Cudd Copr Wedi Pylu",
  "block.minecraft.exposed_cut_copper": "Copr Toredig Wedi Pylu",
  "block.minecraft.exposed_cut_copper_slab": "Slab Copr Toredig Wedi Pylu",
  "block.minecraft.exposed_cut_copper_stairs": "Grisiau Copr Toredig Wedi Pylu",
  "block.minecraft.exposed_lightning_rod": "Rhoden Fellt Wedi Pylu",
  "block.minecraft.farmland": "Tir Fferm",
  "block.minecraft.fern": "Rhedyn",
  "block.minecraft.fire": "Tân",
  "block.minecraft.fire_coral": "Cwrel Tân",
  "block.minecraft.fire_coral_block": "Bloc Cwrel Tân",
  "block.minecraft.fire_coral_fan": "Ffan Cwrel Tân",
  "block.minecraft.fire_coral_wall_fan": "Ffan Wal Gwrel Tân",
  "block.minecraft.firefly_bush": "Llwyn Pryf Tân",
  "block.minecraft.fletching_table": "Bwrdd Pluo",
  "block.minecraft.flower_pot": "Pot Blodau",
  "block.minecraft.flowering_azalea": "Asalea Blodeuog",
  "block.minecraft.flowering_azalea_leaves": "Dail Asalea Blodeuog",
  "block.minecraft.frogspawn": "Grifft Llyffant",
  "block.minecraft.frosted_ice": "Rhew Barugog",
  "block.minecraft.furnace": "Ffwrnais",
  "block.minecraft.gilded_blackstone": "Carregddu Euraid",
  "block.minecraft.glass": "Gwydr",
  "block.minecraft.glass_pane": "Paen Gwydr",
  "block.minecraft.glow_lichen": "Cen Gloyw",
  "block.minecraft.glowstone": "Gloywgarreg",
  "block.minecraft.gold_block": "Bloc Aur",
  "block.minecraft.gold_ore": "Mwyn Aur",
  "block.minecraft.golden_dandelion": "Dant Y Llew Euraid",
  "block.minecraft.granite": "Gwenithfaen",
  "block.minecraft.granite_slab": "Slab Gwenithfaen",
  "block.minecraft.granite_stairs": "Grisiau Gwenithfaen",
  "block.minecraft.granite_wall": "Wal Gwenithfaen",
  "block.minecraft.grass": "Glaswellt",
  "block.minecraft.grass_block": "Bloc Glaswellt",
  "block.minecraft.gravel": "Graean",
  "block.minecraft.gray_banner": "Baner Lwyd",
  "block.minecraft.gray_bed": "Gwely Llwyd",
  "block.minecraft.gray_candle": "Canwyll Lwyd",
  "block.minecraft.gray_candle_cake": "Teisen â Channwyll Llwyd",
  "block.minecraft.gray_carpet": "Carped Llwyd",
  "block.minecraft.gray_concrete": "Concrit Llwyd",
  "block.minecraft.gray_concrete_powder": "Powdr Concrit Llwyd",
  "block.minecraft.gray_glazed_terracotta": "Terracotta Llwyd Gwydrog",
  "block.minecraft.gray_shulker_box": "Blwch Shulker Llwyd",
  "block.minecraft.gray_stained_glass": "Gwydr Lliw Llwyd",
  "block.minecraft.gray_stained_glass_pane": "Paen Gwydr Lliw Llwyd",
  "block.minecraft.gray_terracotta": "Terracotta Llwyd",
  "block.minecraft.gray_wool": "Gwlân Llwyd",
  "block.minecraft.green_banner": "Baner Werdd",
  "block.minecraft.green_bed": "Gwely Gwyrdd",
  "block.minecraft.green_candle": "Canwyll Wyrdd",
  "block.minecraft.green_candle_cake": "Teisen â Channwyll Gwyrdd",
  "block.minecraft.green_carpet": "Carped Gwyrdd",
  "block.minecraft.green_concrete": "Concrit Gwyrdd",
  "block.minecraft.green_concrete_powder": "Powdr Concrit Gwyrdd",
  "block.minecraft.green_glazed_terracotta": "Terracotta Gwyrdd Gwydrog",
  "block.minecraft.green_shulker_box": "Blwch Shulker Gwyrdd",
  "block.minecraft.green_stained_glass": "Gwydr Lliw Gwyrdd",
  "block.minecraft.green_stained_glass_pane": "Paen Gwydr Lliw Gwyrdd",
  "block.minecraft.green_terracotta": "Terracotta Gwyrdd",
  "block.minecraft.green_wool": "Gwlân Gwyrdd",
  "block.minecraft.grindstone": "Hogfaen",
  "block.minecraft.hanging_roots": "Gwreiddiau Crog",
  "block.minecraft.hay_block": "Bwrn Gwair",
  "block.minecraft.heavy_core": "Craidd Trwm",
  "block.minecraft.heavy_weighted_pressure_plate": "Gwasglechen Trwm",
  "block.minecraft.honey_block": "Bloc Mêl",
  "block.minecraft.honeycomb_block": "Bloc Dil Mêl",
  "block.minecraft.hopper": "Hopran",
  "block.minecraft.horn_coral": "Cwrel Corn",
  "block.minecraft.horn_coral_block": "Bloc Cwrel Corn",
  "block.minecraft.horn_coral_fan": "Ffan Gwrel Corn",
  "block.minecraft.horn_coral_wall_fan": "Ffan Wal Gwrel Corn",
  "block.minecraft.ice": "Rhew",
  "block.minecraft.infested_chiseled_stone_bricks": "Briciau Carreg Nadd Pla",
  "block.minecraft.infested_cobblestone": "Crynion Pla",
  "block.minecraft.infested_cracked_stone_bricks": "Briciau Carreg Chwâl Pla",
  "block.minecraft.infested_deepslate": "Dwfnlech Pla",
  "block.minecraft.infested_mossy_stone_bricks": "Briciau Carreg Mwsoglyd Pla",
  "block.minecraft.infested_stone": "Carreg Pla",
  "block.minecraft.infested_stone_bricks": "Briciau Carreg Pla",
  "block.minecraft.iron_bars": "Bariau Haearn",
  "block.minecraft.iron_block": "Bloc Haearn",
  "block.minecraft.iron_chain": "Cadwyn Haearn",
  "block.minecraft.iron_door": "Drws Haearn",
  "block.minecraft.iron_ore": "Mwyn Haearn",
  "block.minecraft.iron_trapdoor": "Drws Cudd Haearn",
  "block.minecraft.jack_o_lantern": "Jac y Lantarn",
  "block.minecraft.jigsaw": "Bloc Jig-sô",
  "block.minecraft.jukebox": "Jiwcbocs",
  "block.minecraft.jungle_button": "Botwm Jyngl",
  "block.minecraft.jungle_door": "Drws Jyngl",
  "block.minecraft.jungle_fence": "Ffens Jyngl",
  "block.minecraft.jungle_fence_gate": "Gât Ffens Jyngl",
  "block.minecraft.jungle_hanging_sign": "Arwydd Crog Jyngl",
  "block.minecraft.jungle_leaves": "Dail Jyngl",
  "block.minecraft.jungle_log": "Boncyff Jyngl",
  "block.minecraft.jungle_planks": "Planciau Jyngl",
  "block.minecraft.jungle_pressure_plate": "Gwasglechen Jyngl",
  "block.minecraft.jungle_sapling": "Glasbren Jyngl",
  "block.minecraft.jungle_shelf": "Silff Jyngl",
  "block.minecraft.jungle_sign": "Arwydd Jyngl",
  "block.minecraft.jungle_slab": "Slab Jyngl",
  "block.minecraft.jungle_stairs": "Grisiau Jyngl",
  "block.minecraft.jungle_trapdoor": "Drws Cudd Jyngl",
  "block.minecraft.jungle_wall_hanging_sign": "Arwydd Wal Crog Jyngl",
  "block.minecraft.jungle_wall_sign": "Arwydd Wal Jyngl",
  "block.minecraft.jungle_wood": "Pren Jyngl",
  "block.minecraft.kelp": "Gwymon",
  "block.minecraft.kelp_plant": "Planhigyn Gwymon",
  "block.minecraft.ladder": "Ysgol",
  "block.minecraft.lantern": "Llusern",
  "block.minecraft.lapis_block": "Bloc Lapis-Laswli",
  "block.minecraft.lapis_ore": "Mwyn Lapis-Laswli",
  "block.minecraft.large_amethyst_bud": "Blagur Mawr Amethyst",
  "block.minecraft.large_fern": "Rhedyn Fawr",
  "block.minecraft.lava": "Lafa",
  "block.minecraft.lava_cauldron": "Crochen Lava",
  "block.minecraft.leaf_litter": "Torllwyth Dail",
  "block.minecraft.lectern": "Darllenfa",
  "block.minecraft.lever": "Lifer",
  "block.minecraft.light": "Golau",
  "block.minecraft.light_blue_banner": "Baner Las Golau",
  "block.minecraft.light_blue_bed": "Gwely Glas Golau",
  "block.minecraft.light_blue_candle": "Canwyll Las Golau",
  "block.minecraft.light_blue_candle_cake": "Teisen â Channwyll Glas Golau",
  "block.minecraft.light_blue_carpet": "Carped Glas Golau",
  "block.minecraft.light_blue_concrete": "Concrit Glas Golau",
  "block.minecraft.light_blue_concrete_powder": "Powdr Concrit Glas Golau",
  "block.minecraft.light_blue_glazed_terracotta": "Terracotta Glas Golau Gwydrog",
  "block.minecraft.light_blue_shulker_box": "Blwch Shulker Glas Golau",
  "block.minecraft.light_blue_stained_glass": "Gwydr Lliw Glas Golau",
  "block.minecraft.light_blue_stained_glass_pane": "Paen Gwydr Lliw Glas Golau",
  "block.minecraft.light_blue_terracotta": "Terracotta Glas Golau",
  "block.minecraft.light_blue_wool": "Gwlân Glas Golau",
  "block.minecraft.light_gray_banner": "Baner Lwyd Golau",
  "block.minecraft.light_gray_bed": "Gwely Llwyd Golau",
  "block.minecraft.light_gray_candle": "Canwyll Lwyd Golau",
  "block.minecraft.light_gray_candle_cake": "Teisen â Channwyll Llwyd Golau",
  "block.minecraft.light_gray_carpet": "Carped Llwyd Golau",
  "block.minecraft.light_gray_concrete": "Concrit Llwyd Golau",
  "block.minecraft.light_gray_concrete_powder": "Powdr Concrit Llwyd Golau",
  "block.minecraft.light_gray_glazed_terracotta": "Terracotta Llwyd Golau Gwydrog",
  "block.minecraft.light_gray_shulker_box": "Blwch Shulker Llwyd Golau",
  "block.minecraft.light_gray_stained_glass": "Gwydr Lliw Llwyd Golau",
  "block.minecraft.light_gray_stained_glass_pane": "Paen Gwydr Lliw Llwyd Golau",
  "block.minecraft.light_gray_terracotta": "Terracotta Llwyd Golau",
  "block.minecraft.light_gray_wool": "Gwlân Llwyd Golau",
  "block.minecraft.light_weighted_pressure_plate": "Gwasglechen Ysgafn",
  "block.minecraft.lightning_rod": "Rhoden Fellt",
  "block.minecraft.lilac": "Lelog",
  "block.minecraft.lily_of_the_valley": "Lili'r Dyffrynnoedd",
  "block.minecraft.lily_pad": "Paden Lili",
  "block.minecraft.lime_banner": "Baner Leim",
  "block.minecraft.lime_bed": "Gwely Leim",
  "block.minecraft.lime_candle": "Canwyll Leim",
  "block.minecraft.lime_candle_cake": "Teisen â Channwyll Leim",
  "block.minecraft.lime_carpet": "Carped Leim",
  "block.minecraft.lime_concrete": "Concrit Leim",
  "block.minecraft.lime_concrete_powder": "Powdr Concrit Leim",
  "block.minecraft.lime_glazed_terracotta": "Terracotta Leim Gwydrog",
  "block.minecraft.lime_shulker_box": "Blwch Shulker Leim",
  "block.minecraft.lime_stained_glass": "Gwydr Lliw Leim",
  "block.minecraft.lime_stained_glass_pane": "Paen Gwydr Lliw Leim",
  "block.minecraft.lime_terracotta": "Terracotta Leim",
  "block.minecraft.lime_wool": "Gwlân Leim",
  "block.minecraft.lodestone": "Tynfaen",
  "block.minecraft.loom": "Gwŷdd",
  "block.minecraft.magenta_banner": "Baner Majenta",
  "block.minecraft.magenta_bed": "Gwely Majenta",
  "block.minecraft.magenta_candle": "Canwyll Majenta",
  "block.minecraft.magenta_candle_cake": "Teisen â Channwyll Majenta",
  "block.minecraft.magenta_carpet": "Carped Majenta",
  "block.minecraft.magenta_concrete": "Concrit Majenta",
  "block.minecraft.magenta_concrete_powder": "Powdr Concrit Majenta",
  "block.minecraft.magenta_glazed_terracotta": "Terracotta Majenta Gwydrog",
  "block.minecraft.magenta_shulker_box": "Blwch Shulker Majenta",
  "block.minecraft.magenta_stained_glass": "Gwydr Lliw Majenta",
  "block.minecraft.magenta_stained_glass_pane": "Paen Gwydr Lliw Majenta",
  "block.minecraft.magenta_terracotta": "Terracotta Majenta",
  "block.minecraft.magenta_wool": "Gwlân Majenta",
  "block.minecraft.magma_block": "Bloc Magma",
  "block.minecraft.mangrove_button": "Botwm Mangrof",
  "block.minecraft.mangrove_door": "Drws Mangrof",
  "block.minecraft.mangrove_fence": "Ffens Mangrof",
  "block.minecraft.mangrove_fence_gate": "Gât Ffens Mangrof",
  "block.minecraft.mangrove_hanging_sign": "Arwydd Crog Mangrof",
  "block.minecraft.mangrove_leaves": "Dail Mangrof",
  "block.minecraft.mangrove_log": "Boncyff Mangrof",
  "block.minecraft.mangrove_planks": "Planciau Mangrof",
  "block.minecraft.mangrove_pressure_plate": "Gwasglechen Mangrof",
  "block.minecraft.mangrove_propagule": "Eginyn Mangrof",
  "block.minecraft.mangrove_roots": "Gwraidd Mangrof",
  "block.minecraft.mangrove_shelf": "Silff Mangrof",
  "block.minecraft.mangrove_sign": "Arwydd Mangrof",
  "block.minecraft.mangrove_slab": "Slab Mangrof",
  "block.minecraft.mangrove_stairs": "Grisiau Mangrof",
  "block.minecraft.mangrove_trapdoor": "Drws Cudd Mangrof",
  "block.minecraft.mangrove_wall_hanging_sign": "Arwydd Wal Crog Mangrof",
  "block.minecraft.mangrove_wall_sign": "Arwydd Wal Mangrof",
  "block.minecraft.mangrove_wood": "Pren Mangrof",
  "block.minecraft.medium_amethyst_bud": "Blagur Canolog Amethyst",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Coesyn Melon",
  "block.minecraft.moss_block": "Bloc Mwsog",
  "block.minecraft.moss_carpet": "Carped Mwsog",
  "block.minecraft.mossy_cobblestone": "Crynion Mwsoglyd",
  "block.minecraft.mossy_cobblestone_slab": "Slab Crynion Mwsoglyd",
  "block.minecraft.mossy_cobblestone_stairs": "Grisiau Crynion Mwsoglyd",
  "block.minecraft.mossy_cobblestone_wall": "Wal Crynion Mwsoglyd",
  "block.minecraft.mossy_stone_brick_slab": "Slab Bricsen Carreg Mwsoglyd",
  "block.minecraft.mossy_stone_brick_stairs": "Grisiau Bricsen Carreg Mwsoglyd",
  "block.minecraft.mossy_stone_brick_wall": "Wal Friciau Carreg Mwsoglyd",
  "block.minecraft.mossy_stone_bricks": "Briciau Carreg Mwsoglyd",
  "block.minecraft.moving_piston": "Piston Symudol",
  "block.minecraft.mud": "Mwd",
  "block.minecraft.mud_brick_slab": "Slab Bricsen Mwd",
  "block.minecraft.mud_brick_stairs": "Grisiau Bricsen Mwd",
  "block.minecraft.mud_brick_wall": "Wal Friciau Mwd",
  "block.minecraft.mud_bricks": "Briciau Mwd",
  "block.minecraft.muddy_mangrove_roots": "Gwraidd Mangrof Mwdlyd",
  "block.minecraft.mushroom_stem": "Coesyn Madarch",
  "block.minecraft.mycelium": "Myseliwm",
  "block.minecraft.nether_brick_fence": "Ffens Fricsen Nether",
  "block.minecraft.nether_brick_slab": "Slab Bricsen Nether",
  "block.minecraft.nether_brick_stairs": "Grisiau Bricsen Nether",
  "block.minecraft.nether_brick_wall": "Wal Friciau Nether",
  "block.minecraft.nether_bricks": "Briciau Nether",
  "block.minecraft.nether_gold_ore": "Mwyn Aur Nether",
  "block.minecraft.nether_portal": "Porth Nether",
  "block.minecraft.nether_quartz_ore": "Mwyn Cwarts Nether",
  "block.minecraft.nether_sprouts": "Egin Nether",
  "block.minecraft.nether_wart": "Chwyn Nether",
  "block.minecraft.nether_wart_block": "Bloc Chwyn Nether",
  "block.minecraft.netherite_block": "Bloc Netherit",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloc Nodyn",
  "block.minecraft.oak_button": "Botwm Derw",
  "block.minecraft.oak_door": "Drws Derw",
  "block.minecraft.oak_fence": "Ffens Dderw",
  "block.minecraft.oak_fence_gate": "Gât Ffens Dderw",
  "block.minecraft.oak_hanging_sign": "Arwydd Crog Derw",
  "block.minecraft.oak_leaves": "Dail Derw",
  "block.minecraft.oak_log": "Boncyff Derw",
  "block.minecraft.oak_planks": "Planciau Derw",
  "block.minecraft.oak_pressure_plate": "Gwasglechen Derw",
  "block.minecraft.oak_sapling": "Glasbren Derw",
  "block.minecraft.oak_shelf": "Silff Derw",
  "block.minecraft.oak_sign": "Arwydd Derw",
  "block.minecraft.oak_slab": "Slab Derw",
  "block.minecraft.oak_stairs": "Grisiau Derw",
  "block.minecraft.oak_trapdoor": "Drws Cudd Derw",
  "block.minecraft.oak_wall_hanging_sign": "Arwydd Wal Crog Derw",
  "block.minecraft.oak_wall_sign": "Arwydd Wal Derw",
  "block.minecraft.oak_wood": "Pren Derw",
  "block.minecraft.observer": "Gwyliwr",
  "block.minecraft.obsidian": "Llosgraig",
  "block.minecraft.ochre_froglight": "Llyffantolau Ocr",
  "block.minecraft.ominous_banner": "Baner Ddrwgargoelus",
  "block.minecraft.open_eyeblossom": "Llygadflodyn Agored",
  "block.minecraft.orange_banner": "Baner Oren",
  "block.minecraft.orange_bed": "Gwely Oren",
  "block.minecraft.orange_candle": "Canwyll Oren",
  "block.minecraft.orange_candle_cake": "Teisen â Channwyll Oren",
  "block.minecraft.orange_carpet": "Carped Oren",
  "block.minecraft.orange_concrete": "Concrit Oren",
  "block.minecraft.orange_concrete_powder": "Powdr Concrit Oren",
  "block.minecraft.orange_glazed_terracotta": "Terracotta Oren Gwydrog",
  "block.minecraft.orange_shulker_box": "Blwch Shulker Oren",
  "block.minecraft.orange_stained_glass": "Gwydr Lliw Oren",
  "block.minecraft.orange_stained_glass_pane": "Paen Gwydr Lliw Oren",
  "block.minecraft.orange_terracotta": "Terracotta Oren",
  "block.minecraft.orange_tulip": "Tiwlip Oren",
  "block.minecraft.orange_wool": "Gwlân Oren",
  "block.minecraft.oxeye_daisy": "Llygad Llo",
  "block.minecraft.oxidized_chiseled_copper": "Copr Nadd Ocsidiedig",
  "block.minecraft.oxidized_copper": "Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_bars": "Bariau Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_bulb": "Bwlb Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_chain": "Cadwyn Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_chest": "Cist Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_door": "Drws Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_golem_statue": "Cerflun Golem Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_grate": "Gratiau Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_lantern": "Llusern Copr Ocsidiedig",
  "block.minecraft.oxidized_copper_trapdoor": "Drws Cudd Copr Ocsidiedig",
  "block.minecraft.oxidized_cut_copper": "Copr Toredig Ocsidiedig",
  "block.minecraft.oxidized_cut_copper_slab": "Slab Copr Toredig Ocsidiedig",
  "block.minecraft.oxidized_cut_copper_stairs": "Grisiau Copr Toredig Ocsidiedig",
  "block.minecraft.oxidized_lightning_rod": "Rhoden Fellt Ocsidiedig",
  "block.minecraft.packed_ice": "Rhew Cywasgedig",
  "block.minecraft.packed_mud": "Mwd Cywasgedig",
  "block.minecraft.pale_hanging_moss": "Mwsog Crog Llwyd",
  "block.minecraft.pale_moss_block": "Bloc Mwsog Llwyd",
  "block.minecraft.pale_moss_carpet": "Carped Mwsog Llwyd",
  "block.minecraft.pale_oak_button": "Botwm Derw Llwyd",
  "block.minecraft.pale_oak_door": "Drws Derw Llwyd",
  "block.minecraft.pale_oak_fence": "Ffens Dderw Llwyd",
  "block.minecraft.pale_oak_fence_gate": "Gât Ffens Dderw Llwyd",
  "block.minecraft.pale_oak_hanging_sign": "Arwydd Crog Derw Llwyd",
  "block.minecraft.pale_oak_leaves": "Dail Derw Llwyd",
  "block.minecraft.pale_oak_log": "Boncyff Derw Llwyd",
  "block.minecraft.pale_oak_planks": "Planciau Derw Llwyd",
  "block.minecraft.pale_oak_pressure_plate": "Gwasglechen Derw Llwyd",
  "block.minecraft.pale_oak_sapling": "Glasbren Derw Llwyd",
  "block.minecraft.pale_oak_shelf": "Silff Derw Llwyd",
  "block.minecraft.pale_oak_sign": "Arwydd Derw Llwyd",
  "block.minecraft.pale_oak_slab": "Slab Derw Llwyd",
  "block.minecraft.pale_oak_stairs": "Grisiau Derw Llwyd",
  "block.minecraft.pale_oak_trapdoor": "Drws Cudd Derw Llwyd",
  "block.minecraft.pale_oak_wall_hanging_sign": "Arwydd Wal Crog Derw Llwyd",
  "block.minecraft.pale_oak_wall_sign": "Arwydd Wal Derw Llwyd",
  "block.minecraft.pale_oak_wood": "Pren Derw Llwyd",
  "block.minecraft.pearlescent_froglight": "Llyffantolau Perlaidd",
  "block.minecraft.peony": "Rhosyn y Mynydd",
  "block.minecraft.petrified_oak_slab": "Slab Derw Petraidd",
  "block.minecraft.piglin_head": "Pen Piglin",
  "block.minecraft.piglin_wall_head": "Pen Wal Piglin",
  "block.minecraft.pink_banner": "Baner Binc",
  "block.minecraft.pink_bed": "Gwely Pinc",
  "block.minecraft.pink_candle": "Canwyll Binc",
  "block.minecraft.pink_candle_cake": "Teisen â Channwyll Pinc",
  "block.minecraft.pink_carpet": "Carped Pinc",
  "block.minecraft.pink_concrete": "Concrit Pinc",
  "block.minecraft.pink_concrete_powder": "Powdr Concrit Pinc",
  "block.minecraft.pink_glazed_terracotta": "Terracotta Pinc Gwydrog",
  "block.minecraft.pink_petals": "Petalau Pinc",
  "block.minecraft.pink_shulker_box": "Blwch Shulker Pinc",
  "block.minecraft.pink_stained_glass": "Gwydr Lliw Pinc",
  "block.minecraft.pink_stained_glass_pane": "Paen Gwydr Lliw Pinc",
  "block.minecraft.pink_terracotta": "Terracotta Pinc",
  "block.minecraft.pink_tulip": "Tiwlip Pinc",
  "block.minecraft.pink_wool": "Gwlân Pinc",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Pen Piston",
  "block.minecraft.pitcher_crop": "Cnwd Piserlys",
  "block.minecraft.pitcher_plant": "Piserlys",
  "block.minecraft.player_head": "Pen Chwaraewr",
  "block.minecraft.player_head.named": "Pen %s",
  "block.minecraft.player_wall_head": "Pen Wal Chwaraewr",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Diferfaen Pigfain",
  "block.minecraft.polished_andesite": "Andesit Caboledig",
  "block.minecraft.polished_andesite_slab": "Slab Andesit Caboledig",
  "block.minecraft.polished_andesite_stairs": "Grisiau Andesit Caboledig",
  "block.minecraft.polished_basalt": "Pilergraig Gloyw",
  "block.minecraft.polished_blackstone": "Carregddu Caboledig",
  "block.minecraft.polished_blackstone_brick_slab": "Slab Briciau Carregddu Caboledig",
  "block.minecraft.polished_blackstone_brick_stairs": "Grisiau Briciau Carregddu Caboledig",
  "block.minecraft.polished_blackstone_brick_wall": "Wal Friciau Carregddu Caboledig",
  "block.minecraft.polished_blackstone_bricks": "Briciau Carregddu Caboledig",
  "block.minecraft.polished_blackstone_button": "Botwm Carregddu Caboledig",
  "block.minecraft.polished_blackstone_pressure_plate": "Gwasglechen Carregddu Caboledig",
  "block.minecraft.polished_blackstone_slab": "Slab Carregddu Caboledig",
  "block.minecraft.polished_blackstone_stairs": "Grisiau Carregddu Caboledig",
  "block.minecraft.polished_blackstone_wall": "Wal Garregddu Caboledig",
  "block.minecraft.polished_deepslate": "Dwfnlech Caboledig",
  "block.minecraft.polished_deepslate_slab": "Slab Dwfnlech Caboledig",
  "block.minecraft.polished_deepslate_stairs": "Grisiau Dwfnlech Caboledig",
  "block.minecraft.polished_deepslate_wall": "Wal Ddwfnlech Caboledig",
  "block.minecraft.polished_diorite": "Diorit Caboledig",
  "block.minecraft.polished_diorite_slab": "Slab Diorit Caboledig",
  "block.minecraft.polished_diorite_stairs": "Grisiau Diorit Caboledig",
  "block.minecraft.polished_granite": "Gwenithfaen Caboledig",
  "block.minecraft.polished_granite_slab": "Slab Gwenithfaen Caboledig",
  "block.minecraft.polished_granite_stairs": "Grisiau Gwenithfaen Caboledig",
  "block.minecraft.polished_tuff": "Twff Caboledig",
  "block.minecraft.polished_tuff_slab": "Slab Twff Caboledig",
  "block.minecraft.polished_tuff_stairs": "Grisiau Twff Caboledig",
  "block.minecraft.polished_tuff_wall": "Wal Twff Caboledig",
  "block.minecraft.poppy": "Pabi",
  "block.minecraft.potatoes": "Tatws",
  "block.minecraft.potted_acacia_sapling": "Glasbren Acesia Mewn Pot",
  "block.minecraft.potted_allium": "Garllegyn Mewn Pot",
  "block.minecraft.potted_azalea_bush": "Asalea Mewn Pot",
  "block.minecraft.potted_azure_bluet": "Gwreiddrudd Las Mewn Pot",
  "block.minecraft.potted_bamboo": "Bambŵ Mewn Pot",
  "block.minecraft.potted_birch_sapling": "Glasbren Bedw Mewn Pot",
  "block.minecraft.potted_blue_orchid": "Tegeirian Glas Mewn Pot",
  "block.minecraft.potted_brown_mushroom": "Madarch Brown Mewn Pot",
  "block.minecraft.potted_cactus": "Cactws Mewn Pot",
  "block.minecraft.potted_cherry_sapling": "Glasbren Ceirios Mewn Pot",
  "block.minecraft.potted_closed_eyeblossom": "Llygadflodyn Cau Mewn Pot",
  "block.minecraft.potted_cornflower": "Penlas Wen Mewn Pot",
  "block.minecraft.potted_crimson_fungus": "Ffwng Rhuddgoch mewn Pot",
  "block.minecraft.potted_crimson_roots": "Gwreiddiau Rhuddgoch mewn Pot",
  "block.minecraft.potted_dandelion": "Dant Y Llew Mewn Pot",
  "block.minecraft.potted_dark_oak_sapling": "Glasbren Derw Tywyll Mewn Pot",
  "block.minecraft.potted_dead_bush": "Llwyn Marw Mewn Pot",
  "block.minecraft.potted_fern": "Rhedyn Mewn Pot",
  "block.minecraft.potted_flowering_azalea_bush": "Asalea Blodeuog Mewn Pot",
  "block.minecraft.potted_golden_dandelion": "Dant Y Llew Euraid Mewn Pot",
  "block.minecraft.potted_jungle_sapling": "Glasbren Jyngl Mewn Pot",
  "block.minecraft.potted_lily_of_the_valley": "Lili'r Dyffrynnoedd Mewn Pot",
  "block.minecraft.potted_mangrove_propagule": "Eginyn Mangrof Mewn Pot",
  "block.minecraft.potted_oak_sapling": "Glasbren Derw Mewn Pot",
  "block.minecraft.potted_open_eyeblossom": "Llygadflodyn Agored Mewn Pot",
  "block.minecraft.potted_orange_tulip": "Tiwlip Oren Mewn Pot",
  "block.minecraft.potted_oxeye_daisy": "Llygad Llo Mewn Pot",
  "block.minecraft.potted_pale_oak_sapling": "Glasbren Derw Llwyd Mewn Pot",
  "block.minecraft.potted_pink_tulip": "Tiwlip Pinc Mewn Pot",
  "block.minecraft.potted_poppy": "Pabi Mewn Pot",
  "block.minecraft.potted_red_mushroom": "Madarch Coch Mewn Pot",
  "block.minecraft.potted_red_tulip": "Tiwlip Coch Mewn Pot",
  "block.minecraft.potted_spruce_sapling": "Glasbren Pyrwydd Mewn Pot",
  "block.minecraft.potted_torchflower": "Torsflodyn Mewn Pot",
  "block.minecraft.potted_warped_fungus": "Ffwng Annaearol mewn Pot",
  "block.minecraft.potted_warped_roots": "Gwreiddiau Annaearol mewn Pot",
  "block.minecraft.potted_white_tulip": "Tiwlip Gwyn Mewn Pot",
  "block.minecraft.potted_wither_rose": "Rhosyn Wither Mewn Pot",
  "block.minecraft.powder_snow": "Eira Powdr",
  "block.minecraft.powder_snow_cauldron": "Crochen Eira Powdr",
  "block.minecraft.powered_rail": "Cledren â Phŵer",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Slab Bricsen Prismarin",
  "block.minecraft.prismarine_brick_stairs": "Grisiau Bricsen Prismarin",
  "block.minecraft.prismarine_bricks": "Briciau Prismarin",
  "block.minecraft.prismarine_slab": "Slab Prismarin",
  "block.minecraft.prismarine_stairs": "Grisiau Prismarin",
  "block.minecraft.prismarine_wall": "Wal Brismarin",
  "block.minecraft.pumpkin": "Pwmpen",
  "block.minecraft.pumpkin_stem": "Coesyn Pwmpen",
  "block.minecraft.purple_banner": "Baner Borffor",
  "block.minecraft.purple_bed": "Gwely Porffor",
  "block.minecraft.purple_candle": "Canwyll Borffor",
  "block.minecraft.purple_candle_cake": "Teisen â Channwyll Porffor",
  "block.minecraft.purple_carpet": "Carped Porffor",
  "block.minecraft.purple_concrete": "Concrit Porffor",
  "block.minecraft.purple_concrete_powder": "Powdr Concrit Porffor",
  "block.minecraft.purple_glazed_terracotta": "Terracotta Porffor Gwydrog",
  "block.minecraft.purple_shulker_box": "Blwch Shulker Porffor",
  "block.minecraft.purple_stained_glass": "Gwydr Lliw Porffor",
  "block.minecraft.purple_stained_glass_pane": "Paen Gwydr Lliw Porffor",
  "block.minecraft.purple_terracotta": "Terracotta Porffor",
  "block.minecraft.purple_wool": "Gwlân Porffor",
  "block.minecraft.purpur_block": "Bloc Purpur",
  "block.minecraft.purpur_pillar": "Piler Purpur",
  "block.minecraft.purpur_slab": "Slab Purpur",
  "block.minecraft.purpur_stairs": "Grisiau Purpur",
  "block.minecraft.quartz_block": "Bloc Cwarts",
  "block.minecraft.quartz_bricks": "Briciau Cwarts",
  "block.minecraft.quartz_pillar": "Colofn Cwarts",
  "block.minecraft.quartz_slab": "Slab Cwarts",
  "block.minecraft.quartz_stairs": "Grisiau Cwarts",
  "block.minecraft.rail": "Cledren",
  "block.minecraft.raw_copper_block": "Bloc Copr Crai",
  "block.minecraft.raw_gold_block": "Bloc Aur Crai",
  "block.minecraft.raw_iron_block": "Bloc Haearn Crai",
  "block.minecraft.red_banner": "Baner Goch",
  "block.minecraft.red_bed": "Gwely Coch",
  "block.minecraft.red_candle": "Canwyll Goch",
  "block.minecraft.red_candle_cake": "Teisen â Channwyll Coch",
  "block.minecraft.red_carpet": "Carped Coch",
  "block.minecraft.red_concrete": "Concrit Coch",
  "block.minecraft.red_concrete_powder": "Powdr Concrit Coch",
  "block.minecraft.red_glazed_terracotta": "Terracotta Coch Gwydrog",
  "block.minecraft.red_mushroom": "Madarchen Goch",
  "block.minecraft.red_mushroom_block": "Bloc Madarch Coch",
  "block.minecraft.red_nether_brick_slab": "Slab Bricsen Nether Coch",
  "block.minecraft.red_nether_brick_stairs": "Grisiau Bricsen Nether Coch",
  "block.minecraft.red_nether_brick_wall": "Wal Friciau Nether Coch",
  "block.minecraft.red_nether_bricks": "Briciau Nether Coch",
  "block.minecraft.red_sand": "Tywod Coch",
  "block.minecraft.red_sandstone": "Tywodfaen Coch",
  "block.minecraft.red_sandstone_slab": "Slab Tywodfaen Coch",
  "block.minecraft.red_sandstone_stairs": "Grisiau Tywodfaen Coch",
  "block.minecraft.red_sandstone_wall": "Wal Dywodfaen Coch",
  "block.minecraft.red_shulker_box": "Blwch Shulker Coch",
  "block.minecraft.red_stained_glass": "Gwydr Lliw Coch",
  "block.minecraft.red_stained_glass_pane": "Paen Gwydr Lliw Coch",
  "block.minecraft.red_terracotta": "Terracotta Coch",
  "block.minecraft.red_tulip": "Tiwlip Coch",
  "block.minecraft.red_wool": "Gwlân Coch",
  "block.minecraft.redstone_block": "Bloc Redstone",
  "block.minecraft.redstone_lamp": "Lamp Redstone",
  "block.minecraft.redstone_ore": "Mwyn Redstone",
  "block.minecraft.redstone_torch": "Tors Redstone",
  "block.minecraft.redstone_wall_torch": "Tors Wal Redstone",
  "block.minecraft.redstone_wire": "Gwifren Redstone",
  "block.minecraft.reinforced_deepslate": "Dwfnlech Dur",
  "block.minecraft.repeater": "Ailadroddwr Redstone",
  "block.minecraft.repeating_command_block": "Bloc Gorchymyn Ailadroddol",
  "block.minecraft.resin_block": "Bloc Resin",
  "block.minecraft.resin_brick_slab": "Slab Bricsen Resin",
  "block.minecraft.resin_brick_stairs": "Grisiau Bricsen Resin",
  "block.minecraft.resin_brick_wall": "Wal Friciau Resin",
  "block.minecraft.resin_bricks": "Briciau Resin",
  "block.minecraft.resin_clump": "Talp Resin",
  "block.minecraft.respawn_anchor": "Angor Atgyfodi",
  "block.minecraft.rooted_dirt": "Pridd Gwreiddiog",
  "block.minecraft.rose_bush": "Llwyn Rhosod",
  "block.minecraft.sand": "Tywod",
  "block.minecraft.sandstone": "Tywodfaen",
  "block.minecraft.sandstone_slab": "Slab Tywodfaen",
  "block.minecraft.sandstone_stairs": "Grisiau Tywodfaen",
  "block.minecraft.sandstone_wall": "Wal Dywodfaen",
  "block.minecraft.scaffolding": "Sgaffaldiau",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalydd Sculk",
  "block.minecraft.sculk_sensor": "Synhwyrydd Sculk",
  "block.minecraft.sculk_shrieker": "Sgrechiwr Sculk",
  "block.minecraft.sculk_vein": "Gwythien Sculk",
  "block.minecraft.sea_lantern": "Llusern Fôr",
  "block.minecraft.sea_pickle": "Picl Môr",
  "block.minecraft.seagrass": "Morwellt",
  "block.minecraft.set_spawn": "Gosodwyd man atgyfodi",
  "block.minecraft.short_dry_grass": "Glaswellt Byr Sych",
  "block.minecraft.short_grass": "Glaswellt Byr",
  "block.minecraft.shroomlight": "Goleuffwng",
  "block.minecraft.shulker_box": "Blwch Shulker",
  "block.minecraft.skeleton_skull": "Penglog Sgerbwd",
  "block.minecraft.skeleton_wall_skull": "Penglog Wal Sgerbwd",
  "block.minecraft.slime_block": "Bloc Sleim",
  "block.minecraft.small_amethyst_bud": "Blagur Bychain Amethyst",
  "block.minecraft.small_dripleaf": "Diferddeilen Fach",
  "block.minecraft.smithing_table": "Bwrdd Gwaith Gof",
  "block.minecraft.smoker": "Ffwrn Fygu",
  "block.minecraft.smooth_basalt": "Pilergraig Llyfn",
  "block.minecraft.smooth_quartz": "Bloc Cwartz Llyfn",
  "block.minecraft.smooth_quartz_slab": "Slab Cwarts Llyfn",
  "block.minecraft.smooth_quartz_stairs": "Grisiau Cwarts Llyfn",
  "block.minecraft.smooth_red_sandstone": "Tywodfaen Coch Llyfn",
  "block.minecraft.smooth_red_sandstone_slab": "Slab Tywodfaen Coch Llyfn",
  "block.minecraft.smooth_red_sandstone_stairs": "Grisiau Tywodfaen Coch Llyfn",
  "block.minecraft.smooth_sandstone": "Tywodfaen Llyfn",
  "block.minecraft.smooth_sandstone_slab": "Slab Tywodfaen Llyfn",
  "block.minecraft.smooth_sandstone_stairs": "Grisiau Tywodfaen Llyfn",
  "block.minecraft.smooth_stone": "Carreg Llyfn",
  "block.minecraft.smooth_stone_slab": "Slab Carreg Llyfn",
  "block.minecraft.sniffer_egg": "Ŵy Ffroenwr",
  "block.minecraft.snow": "Eira",
  "block.minecraft.snow_block": "Bloc Eira",
  "block.minecraft.soul_campfire": "Tân Gwersyll Enaid",
  "block.minecraft.soul_fire": "Tân Enaid",
  "block.minecraft.soul_lantern": "Llusern Enaid",
  "block.minecraft.soul_sand": "Tywod Enaid",
  "block.minecraft.soul_soil": "Pridd Enaid",
  "block.minecraft.soul_torch": "Tors Enaid",
  "block.minecraft.soul_wall_torch": "Tors Wal Enaid",
  "block.minecraft.spawn.not_valid": "Nid oes gennych wely cartref neu angor atgyfodi wedi'i wefrio, neu roedd wedi'i rwystro",
  "block.minecraft.spawner": "Sil Bwystfilod",
  "block.minecraft.spawner.desc1": "Rhyngweithio ag Wy Geni:",
  "block.minecraft.spawner.desc2": "Gosod Math o Greadur",
  "block.minecraft.sponge": "Sbwng",
  "block.minecraft.spore_blossom": "Blodeuyn Sbor",
  "block.minecraft.spruce_button": "Botwm Pyrwydd",
  "block.minecraft.spruce_door": "Drws Pyrwydd",
  "block.minecraft.spruce_fence": "Ffens Byrwydd",
  "block.minecraft.spruce_fence_gate": "Gât Ffens Byrwydd",
  "block.minecraft.spruce_hanging_sign": "Arwydd Crog Pyrwydd",
  "block.minecraft.spruce_leaves": "Dail Pyrwydd",
  "block.minecraft.spruce_log": "Boncyff Pyrwydd",
  "block.minecraft.spruce_planks": "Planciau Pyrwydd",
  "block.minecraft.spruce_pressure_plate": "Gwasglechen Pyrwydd",
  "block.minecraft.spruce_sapling": "Glasbren Pyrwydd",
  "block.minecraft.spruce_shelf": "Silff Pyrwydd",
  "block.minecraft.spruce_sign": "Arwydd Pyrwydd",
  "block.minecraft.spruce_slab": "Slab Pyrwydd",
  "block.minecraft.spruce_stairs": "Grisiau Pyrwydd",
  "block.minecraft.spruce_trapdoor": "Drws Cudd Pyrwydd",
  "block.minecraft.spruce_wall_hanging_sign": "Arwydd Wal Crog Pyrwydd",
  "block.minecraft.spruce_wall_sign": "Arwydd Mur Pyrwydd",
  "block.minecraft.spruce_wood": "Pren Pyrwydd",
  "block.minecraft.sticky_piston": "Piston Gludiog",
  "block.minecraft.stone": "Carreg",
  "block.minecraft.stone_brick_slab": "Slab Bricsen Carreg",
  "block.minecraft.stone_brick_stairs": "Grisiau Bricsen Carreg",
  "block.minecraft.stone_brick_wall": "Wal Friciau Carreg",
  "block.minecraft.stone_bricks": "Briciau Carreg",
  "block.minecraft.stone_button": "Botwm Carreg",
  "block.minecraft.stone_pressure_plate": "Gwasglechen Carreg",
  "block.minecraft.stone_slab": "Slab Carreg",
  "block.minecraft.stone_stairs": "Grisiau Carreg",
  "block.minecraft.stonecutter": "Naddwr Cerrig",
  "block.minecraft.stripped_acacia_log": "Boncyff Acesia Moel",
  "block.minecraft.stripped_acacia_wood": "Pren Acesia Moel",
  "block.minecraft.stripped_bamboo_block": "Bloc Bambŵ Moel",
  "block.minecraft.stripped_birch_log": "Boncyff Bedw Moel",
  "block.minecraft.stripped_birch_wood": "Pren Bedw Moel",
  "block.minecraft.stripped_cherry_log": "Boncyff Ceirios Moel",
  "block.minecraft.stripped_cherry_wood": "Pren Ceirios Moel",
  "block.minecraft.stripped_crimson_hyphae": "Hyffae Rhuddgoch Moel",
  "block.minecraft.stripped_crimson_stem": "Coesyn Rhuddgoch Moel",
  "block.minecraft.stripped_dark_oak_log": "Boncyff Derw Tywyll Moel",
  "block.minecraft.stripped_dark_oak_wood": "Pren Derw Tywyll Moel",
  "block.minecraft.stripped_jungle_log": "Boncyff Jyngl Moel",
  "block.minecraft.stripped_jungle_wood": "Coed Jyngl Moel",
  "block.minecraft.stripped_mangrove_log": "Boncyff Mangrof Moel",
  "block.minecraft.stripped_mangrove_wood": "Pren Mangrof Moel",
  "block.minecraft.stripped_oak_log": "Boncyff Derw Moel",
  "block.minecraft.stripped_oak_wood": "Pren Derw Moel",
  "block.minecraft.stripped_pale_oak_log": "Boncyff Derw Llwyd Moel",
  "block.minecraft.stripped_pale_oak_wood": "Pren Derw Llwyd Moel",
  "block.minecraft.stripped_spruce_log": "Boncyff Pyrwydd Moel",
  "block.minecraft.stripped_spruce_wood": "Pren Pyrwydd Moel",
  "block.minecraft.stripped_warped_hyphae": "Hyffae Annaearol Moel",
  "block.minecraft.stripped_warped_stem": "Coesyn Annaearol Moel",
  "block.minecraft.structure_block": "Bloc Adeileddol",
  "block.minecraft.structure_void": "Gwagle Strwythur",
  "block.minecraft.sugar_cane": "Cansen Siwgr",
  "block.minecraft.sunflower": "Blodyn yr Haul",
  "block.minecraft.suspicious_gravel": "Graean Amheus",
  "block.minecraft.suspicious_sand": "Tywod Amheus",
  "block.minecraft.sweet_berry_bush": "Llwyn Aeron Melys",
  "block.minecraft.tall_dry_grass": "Glaswellt Hir Sych",
  "block.minecraft.tall_grass": "Glaswellt Hir",
  "block.minecraft.tall_seagrass": "Morwellt Tal",
  "block.minecraft.target": "Targed",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Bloc Prawf",
  "block.minecraft.test_instance_block": "Bloc Enghraifft Prawf",
  "block.minecraft.tinted_glass": "Gwydr Arlliw",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Analluogir ffrwydradau TNT",
  "block.minecraft.torch": "Tors",
  "block.minecraft.torchflower": "Torsflodyn",
  "block.minecraft.torchflower_crop": "Cnwd Torsflodyn",
  "block.minecraft.trapped_chest": "Magl-gist",
  "block.minecraft.trial_spawner": "Sil Treial",
  "block.minecraft.tripwire": "Weiren Faglu",
  "block.minecraft.tripwire_hook": "Bachyn Weiren Faglu",
  "block.minecraft.tube_coral": "Cwrel Piben",
  "block.minecraft.tube_coral_block": "Bloc Cwrel Piben",
  "block.minecraft.tube_coral_fan": "Ffan Cwrel Piben",
  "block.minecraft.tube_coral_wall_fan": "Ffan Wal Gwrel Piben",
  "block.minecraft.tuff": "Twff",
  "block.minecraft.tuff_brick_slab": "Slab Briciau Twff",
  "block.minecraft.tuff_brick_stairs": "Grisiau Briciau Twff",
  "block.minecraft.tuff_brick_wall": "Wal Friciau Twff",
  "block.minecraft.tuff_bricks": "Briciau Twff",
  "block.minecraft.tuff_slab": "Slab Twff",
  "block.minecraft.tuff_stairs": "Grisiau Twff",
  "block.minecraft.tuff_wall": "Wal Twff",
  "block.minecraft.turtle_egg": "Wy Crwban",
  "block.minecraft.twisting_vines": "Gwinwydd Dirdro",
  "block.minecraft.twisting_vines_plant": "Planhigyn Gwinwydd Dirdro",
  "block.minecraft.vault": "Cell",
  "block.minecraft.verdant_froglight": "Llyffantolau Irlas",
  "block.minecraft.vine": "Gwinwydd",
  "block.minecraft.void_air": "Aer Gwagle",
  "block.minecraft.wall_torch": "Tors Wal",
  "block.minecraft.warped_button": "Botwm Annaearol",
  "block.minecraft.warped_door": "Drws Annaearol",
  "block.minecraft.warped_fence": "Ffens Annaearol",
  "block.minecraft.warped_fence_gate": "Gât Ffens Annaearol",
  "block.minecraft.warped_fungus": "Ffwng Annaearol",
  "block.minecraft.warped_hanging_sign": "Arwydd Crog Annaearol",
  "block.minecraft.warped_hyphae": "Hyffae Annaearol",
  "block.minecraft.warped_nylium": "Neliwm Annaearol",
  "block.minecraft.warped_planks": "Planciau Annaearol",
  "block.minecraft.warped_pressure_plate": "Gwasglechen Annaearol",
  "block.minecraft.warped_roots": "Gwreiddiau Annaearol",
  "block.minecraft.warped_shelf": "Silff Annaearol",
  "block.minecraft.warped_sign": "Arwydd Annaearol",
  "block.minecraft.warped_slab": "Slab Annaearol",
  "block.minecraft.warped_stairs": "Grisiau Annaearol",
  "block.minecraft.warped_stem": "Coesyn Annaearol",
  "block.minecraft.warped_trapdoor": "Drws Cudd Annaearol",
  "block.minecraft.warped_wall_hanging_sign": "Arwydd Wal Crog Annaearol",
  "block.minecraft.warped_wall_sign": "Arwydd Wal Annaearol",
  "block.minecraft.warped_wart_block": "Bloc Chwyn Annaearol",
  "block.minecraft.water": "Dŵr",
  "block.minecraft.water_cauldron": "Crochen Ddŵr",
  "block.minecraft.waxed_chiseled_copper": "Copr Cwyrog Nadd",
  "block.minecraft.waxed_copper_bars": "Bariau Copr Cwyrog",
  "block.minecraft.waxed_copper_block": "Bloc Copr Cwyrog",
  "block.minecraft.waxed_copper_bulb": "Bwlb Copr Cwyrog",
  "block.minecraft.waxed_copper_chain": "Cadwyn Copr Cwyrog",
  "block.minecraft.waxed_copper_chest": "Cist Copr Cwyrog",
  "block.minecraft.waxed_copper_door": "Drws Copr Cwyrog",
  "block.minecraft.waxed_copper_golem_statue": "Cerflun Golem Copr Cwyrog",
  "block.minecraft.waxed_copper_grate": "Gratiau Copr Cwyrog",
  "block.minecraft.waxed_copper_lantern": "Llusern Copr Cwyrog",
  "block.minecraft.waxed_copper_trapdoor": "Drws Cudd Copr Cwyrog",
  "block.minecraft.waxed_cut_copper": "Copr Cwyrog Toredig",
  "block.minecraft.waxed_cut_copper_slab": "Slab Copr Cwyrog Toredig",
  "block.minecraft.waxed_cut_copper_stairs": "Grisiau Copr Cwyrog Toredig",
  "block.minecraft.waxed_exposed_chiseled_copper": "Copr Cwyrog Nadd Wedi Pylu",
  "block.minecraft.waxed_exposed_copper": "Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_bars": "Bariau Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_bulb": "Bwlb Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_chain": "Cadwyn Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_chest": "Cist Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_door": "Drws Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Cerflun Golem Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_grate": "Gratiau Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_lantern": "Llusern Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Drws Cudd Copr Cwyrog Wedi Pylu",
  "block.minecraft.waxed_exposed_cut_copper": "Copr Cwyrog Toredig Wedi Pylu",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Slab Copr Cwyrog Toredig Wedi Pylu",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Grisiau Copr Cwyrog Toredig Wedi Pylu",
  "block.minecraft.waxed_exposed_lightning_rod": "Rhoden Fellt Cwyrog Wedi Pylu",
  "block.minecraft.waxed_lightning_rod": "Rhoden Fellt Cwyrog",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Copr Nadd Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper": "Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_bars": "Bariau Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bwlb Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadwyn Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_chest": "Cist Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_door": "Drws Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Cerflun Copr Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_grate": "Gratiau Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_lantern": "Llusern Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Drws Cudd Copr Cwyrog Ocsidiedig",
  "block.minecraft.waxed_oxidized_cut_copper": "Copr Cwyrog Toredig Ocsidiedig",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Slab Copr Cwyrog Toredig Ocsidiedig",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Grisiau Copr Cwyrog Toredig Ocsidiedig",
  "block.minecraft.waxed_oxidized_lightning_rod": "Rhoden Fellt Cwyrog Ocsidiedig",
  "block.minecraft.waxed_weathered_chiseled_copper": "Copr Cwyrog Nadd Hindreuliedig",
  "block.minecraft.waxed_weathered_copper": "Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_bars": "Bariau Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_bulb": "Bwlb Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_chain": "Cadwyn Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_chest": "Cist Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_door": "Drws Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Cerflun Golem Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_grate": "Gratiau Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_lantern": "Llusern Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Drws Cudd Copr Cwyrog Hindreuliedig",
  "block.minecraft.waxed_weathered_cut_copper": "Copr Cwyrog Toredig Hindreuliedig",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Slab Copr Cwyrog Toredig Hindreuliedig",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Grisiau Copr Cwyrog Toredig Hindreuliedig",
  "block.minecraft.waxed_weathered_lightning_rod": "Rhoden Fellt Cwyrog Hindreuliedig",
  "block.minecraft.weathered_chiseled_copper": "Copr Nadd Hindreuliedig",
  "block.minecraft.weathered_copper": "Copr Hindreuliedig",
  "block.minecraft.weathered_copper_bars": "Bariau Copr Hindreuliedig",
  "block.minecraft.weathered_copper_bulb": "Bwlb Copr Hindreuliedig",
  "block.minecraft.weathered_copper_chain": "Cadwyn Copr Hindreuliedig",
  "block.minecraft.weathered_copper_chest": "Cist Copr Hindreuliedig",
  "block.minecraft.weathered_copper_door": "Drws Copr Hindreuliedig",
  "block.minecraft.weathered_copper_golem_statue": "Cerflun Golem Copr Hindreuliedig",
  "block.minecraft.weathered_copper_grate": "Gratiau Copr Hindreuliedig",
  "block.minecraft.weathered_copper_lantern": "Llusern Copr Hindreuliedig",
  "block.minecraft.weathered_copper_trapdoor": "Drws Cudd Copr Hindreuliedig",
  "block.minecraft.weathered_cut_copper": "Copr Toredig Hindreuliedig",
  "block.minecraft.weathered_cut_copper_slab": "Slab Copr Toredig Hindreuliedig",
  "block.minecraft.weathered_cut_copper_stairs": "Grisiau Copr Toredig Hindreuliedig",
  "block.minecraft.weathered_lightning_rod": "Rhoden Fellt Hindreuliedig",
  "block.minecraft.weeping_vines": "Gwinwydd Wylofus",
  "block.minecraft.weeping_vines_plant": "Planhigyn Gwinwydd Wylofus",
  "block.minecraft.wet_sponge": "Sbwng Gwlyb",
  "block.minecraft.wheat": "Cnydau Gwenith",
  "block.minecraft.white_banner": "Baner Wen",
  "block.minecraft.white_bed": "Gwely Gwyn",
  "block.minecraft.white_candle": "Canwyll Wen",
  "block.minecraft.white_candle_cake": "Teisen â Channwyll Gwyn",
  "block.minecraft.white_carpet": "Carped Gwyn",
  "block.minecraft.white_concrete": "Concrit Gwyn",
  "block.minecraft.white_concrete_powder": "Powdr Concrit Gwyn",
  "block.minecraft.white_glazed_terracotta": "Terracotta Gwyn Gwydrog",
  "block.minecraft.white_shulker_box": "Blwch Shulker Gwyn",
  "block.minecraft.white_stained_glass": "Gwydr Lliw Gwyn",
  "block.minecraft.white_stained_glass_pane": "Paen Gwydr Lliw Gwyn",
  "block.minecraft.white_terracotta": "Terracotta Gwyn",
  "block.minecraft.white_tulip": "Tiwlip Gwyn",
  "block.minecraft.white_wool": "Gwlân Gwyn",
  "block.minecraft.wildflowers": "Blodau Gwyllt",
  "block.minecraft.wither_rose": "Rhosyn Wither",
  "block.minecraft.wither_skeleton_skull": "Penglog Sgerbwd Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Penglog Wal Sgerbwd Wither",
  "block.minecraft.yellow_banner": "Baner Felen",
  "block.minecraft.yellow_bed": "Gwely Melyn",
  "block.minecraft.yellow_candle": "Canwyll Felyn",
  "block.minecraft.yellow_candle_cake": "Teisen â Channwyll Melyn",
  "block.minecraft.yellow_carpet": "Carped Melyn",
  "block.minecraft.yellow_concrete": "Concrit Melyn",
  "block.minecraft.yellow_concrete_powder": "Powdr Concrit Melyn",
  "block.minecraft.yellow_glazed_terracotta": "Terracotta Melyn Gwydrog",
  "block.minecraft.yellow_shulker_box": "Blwch Shulker Melyn",
  "block.minecraft.yellow_stained_glass": "Gwydr Lliw Melyn",
  "block.minecraft.yellow_stained_glass_pane": "Paen Gwydr Lliw Melyn",
  "block.minecraft.yellow_terracotta": "Terracotta Melyn",
  "block.minecraft.yellow_wool": "Gwlân Melyn",
  "block.minecraft.zombie_head": "Pen Sombi",
  "block.minecraft.zombie_wall_head": "Pen Wal Sombi",
  "item.minecraft.acacia_boat": "Cwch Acesia",
  "item.minecraft.acacia_chest_boat": "Cwch Acesia â Chist",
  "item.minecraft.allay_spawn_egg": "Wy Geni Helpllaw",
  "item.minecraft.amethyst_shard": "Telchyn Amethyst",
  "item.minecraft.angler_pottery_shard": "Darn Crochenwaith Pysgotwr",
  "item.minecraft.angler_pottery_sherd": "Darn Crochenwaith Pysgotwr",
  "item.minecraft.apple": "Afal",
  "item.minecraft.archer_pottery_shard": "Darn Crochenwaith Saethwr",
  "item.minecraft.archer_pottery_sherd": "Darn Crochenwaith Saethwr",
  "item.minecraft.armadillo_scute": "Sgwtela Armadilo",
  "item.minecraft.armadillo_spawn_egg": "Ŵy Geni Armadilo",
  "item.minecraft.armor_stand": "Daliadur Arfwisg",
  "item.minecraft.arms_up_pottery_shard": "Darn Crochenwaith Breichiau",
  "item.minecraft.arms_up_pottery_sherd": "Darn Crochenwaith Breichiau",
  "item.minecraft.arrow": "Saeth",
  "item.minecraft.axolotl_bucket": "Bwced o Acsolotlod",
  "item.minecraft.axolotl_spawn_egg": "Wy Geni Acsolotl",
  "item.minecraft.baked_potato": "Taten Pob",
  "item.minecraft.bamboo_chest_raft": "Rafft Fambŵ â Chist",
  "item.minecraft.bamboo_raft": "Rafft Fambŵ",
  "item.minecraft.bat_spawn_egg": "Wy Geni Ystlum",
  "item.minecraft.bee_spawn_egg": "Ŵy Geni Gwenyn",
  "item.minecraft.beef": "Cig Eidion Amrwd",
  "item.minecraft.beetroot": "Betys",
  "item.minecraft.beetroot_seeds": "Hadau Betys",
  "item.minecraft.beetroot_soup": "Cawl Betys",
  "item.minecraft.birch_boat": "Cwch Bedw",
  "item.minecraft.birch_chest_boat": "Cwch Bedw â Chist",
  "item.minecraft.black_bundle": "Bwndel Du",
  "item.minecraft.black_dye": "Llifyn Du",
  "item.minecraft.black_harness": "Harnais Du",
  "item.minecraft.blade_pottery_shard": "Darn Crochenwaith Cleddyf",
  "item.minecraft.blade_pottery_sherd": "Darn Crochenwaith Cleddyf",
  "item.minecraft.blaze_powder": "Llwch Tânfwystfil",
  "item.minecraft.blaze_rod": "Gwialen Tânfwystfil",
  "item.minecraft.blaze_spawn_egg": "Wy Geni Tanfwystfil",
  "item.minecraft.blue_bundle": "Bwndel Glas",
  "item.minecraft.blue_dye": "Llifyn Glas",
  "item.minecraft.blue_egg": "Ŵy Glas",
  "item.minecraft.blue_harness": "Harnais Glas",
  "item.minecraft.bogged_spawn_egg": "Wy Geni Corslyd",
  "item.minecraft.bolt_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Addurn Arfwisg Bollten",
  "item.minecraft.bone": "Asgwrn",
  "item.minecraft.bone_meal": "Blawd Esgyrn",
  "item.minecraft.book": "Llyfr",
  "item.minecraft.bordure_indented_banner_pattern": "Patrwm Baner Bordor Rasyd",
  "item.minecraft.bow": "Bwa",
  "item.minecraft.bowl": "Powlen",
  "item.minecraft.bread": "Bara",
  "item.minecraft.breeze_rod": "Gwialen Awel",
  "item.minecraft.breeze_spawn_egg": "Wy Geni Awel",
  "item.minecraft.brewer_pottery_shard": "Darn Crochenwaith Bragu",
  "item.minecraft.brewer_pottery_sherd": "Darn Crochenwaith Bragu",
  "item.minecraft.brewing_stand": "Safle Bragu",
  "item.minecraft.brick": "Bricsen",
  "item.minecraft.brown_bundle": "Bwndel Brown",
  "item.minecraft.brown_dye": "Llifyn Brown",
  "item.minecraft.brown_egg": "Ŵy Brown",
  "item.minecraft.brown_harness": "Harnais Brown",
  "item.minecraft.brush": "Brwsh",
  "item.minecraft.bucket": "Bwced",
  "item.minecraft.bundle": "Bwndel",
  "item.minecraft.bundle.empty": "Gwag",
  "item.minecraft.bundle.empty.description": "Yn gallu dal pentwr cymysg o eitemau",
  "item.minecraft.bundle.full": "Llawn",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Darn Crochenwaith Llosgi",
  "item.minecraft.burn_pottery_sherd": "Darn Crochenwaith Llosgi",
  "item.minecraft.camel_husk_spawn_egg": "Wy Geni Cibyn Camel",
  "item.minecraft.camel_spawn_egg": "Wy Geni Camel",
  "item.minecraft.carrot": "Moronen",
  "item.minecraft.carrot_on_a_stick": "Moronen ar Ffon",
  "item.minecraft.cat_spawn_egg": "Wy Geni Cath",
  "item.minecraft.cauldron": "Crochan",
  "item.minecraft.cave_spider_spawn_egg": "Wy Geni Pryf Cop Ogof",
  "item.minecraft.chainmail_boots": "Esgidiau Maelwisg",
  "item.minecraft.chainmail_chestplate": "Dwyfronneg Maelwisg",
  "item.minecraft.chainmail_helmet": "Helmed Maelwisg",
  "item.minecraft.chainmail_leggings": "Legins Maelwisg",
  "item.minecraft.charcoal": "Golosg",
  "item.minecraft.cherry_boat": "Cwch Ceirios",
  "item.minecraft.cherry_chest_boat": "Cwch Ceirios â Chist",
  "item.minecraft.chest_minecart": "Cart Pwll â Chist",
  "item.minecraft.chicken": "Cyw Iar Amrwd",
  "item.minecraft.chicken_spawn_egg": "Wy Geni Iar",
  "item.minecraft.chorus_fruit": "Ffrwyth Corws",
  "item.minecraft.clay_ball": "Pelen Clai",
  "item.minecraft.clock": "Cloc",
  "item.minecraft.coal": "Glo",
  "item.minecraft.coast_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Addurn Arfwisg Arfordir",
  "item.minecraft.cocoa_beans": "Ffa Coco",
  "item.minecraft.cod": "Penfras Amrwd",
  "item.minecraft.cod_bucket": "Bwced o Benfrasiaid",
  "item.minecraft.cod_spawn_egg": "Wy Geni Penfras",
  "item.minecraft.command_block_minecart": "Cart Pwll gyda Bloc Gorchymyn",
  "item.minecraft.compass": "Cwmpawd",
  "item.minecraft.cooked_beef": "Stecen",
  "item.minecraft.cooked_chicken": "Cyw Iar Rhost",
  "item.minecraft.cooked_cod": "Penfras Rhost",
  "item.minecraft.cooked_mutton": "Cig Dafad Rhost",
  "item.minecraft.cooked_porkchop": "Porc Rhost",
  "item.minecraft.cooked_rabbit": "Cwningen Rhost",
  "item.minecraft.cooked_salmon": "Eog Rhost",
  "item.minecraft.cookie": "Bisgeden",
  "item.minecraft.copper_axe": "Bwyell Copr",
  "item.minecraft.copper_boots": "Esgidiau Copr",
  "item.minecraft.copper_chestplate": "Dwyfronneg Copr",
  "item.minecraft.copper_golem_spawn_egg": "Wy Geni Golem Copr",
  "item.minecraft.copper_helmet": "Helmed Copr",
  "item.minecraft.copper_hoe": "Hof Copr",
  "item.minecraft.copper_horse_armor": "Arfwisg Ceffyl Copr",
  "item.minecraft.copper_ingot": "Bar Copr",
  "item.minecraft.copper_leggings": "Legins Copr",
  "item.minecraft.copper_nautilus_armor": "Arfwisg Nawtilws Copr",
  "item.minecraft.copper_nugget": "Clap Copr",
  "item.minecraft.copper_pickaxe": "Caib Copr",
  "item.minecraft.copper_shovel": "Rhaw Copr",
  "item.minecraft.copper_spear": "Picell Gopr",
  "item.minecraft.copper_sword": "Cleddyf Copr",
  "item.minecraft.cow_spawn_egg": "Wy Geni Buwch",
  "item.minecraft.creaking_spawn_egg": "Wy Geni Gwich",
  "item.minecraft.creeper_banner_pattern": "Patrwm Baner",
  "item.minecraft.creeper_banner_pattern.desc": "Luws Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Patrwm Baner Luws Creeper",
  "item.minecraft.creeper_spawn_egg": "Wy Geni Creeper",
  "item.minecraft.crossbow": "Bwa Croes",
  "item.minecraft.crossbow.projectile": "Taflegryn:",
  "item.minecraft.crossbow.projectile.multiple": "Taflegryn: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Taflegryn: %s",
  "item.minecraft.cyan_bundle": "Bwndel Gwyrddlas",
  "item.minecraft.cyan_dye": "Llifyn Gwyrddlas",
  "item.minecraft.cyan_harness": "Harnais Gwyrddlas",
  "item.minecraft.danger_pottery_shard": "Darn Crochenwaith Peryg",
  "item.minecraft.danger_pottery_sherd": "Darn Crochenwaith Peryg",
  "item.minecraft.dark_oak_boat": "Cwch Derw Tywyll",
  "item.minecraft.dark_oak_chest_boat": "Cwch Derw Tywyll â Chist",
  "item.minecraft.debug_stick": "Ffon Dadfygio",
  "item.minecraft.debug_stick.empty": "Nid oes gan %s unrhyw nodweddion",
  "item.minecraft.debug_stick.select": "dewiswyd \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" i %s",
  "item.minecraft.diamond": "Diemwnt",
  "item.minecraft.diamond_axe": "Bwyell Diemwnt",
  "item.minecraft.diamond_boots": "Esgidiau Diemwnt",
  "item.minecraft.diamond_chestplate": "Dwyfronneg Diemwnt",
  "item.minecraft.diamond_helmet": "Helmed Diemwnt",
  "item.minecraft.diamond_hoe": "Hof Diemwnt",
  "item.minecraft.diamond_horse_armor": "Arfwisg Ceffyl Diemwnt",
  "item.minecraft.diamond_leggings": "Legins Diemwnt",
  "item.minecraft.diamond_nautilus_armor": "Arfwisg Nawtilws Diemwnt",
  "item.minecraft.diamond_pickaxe": "Caib Diemwnt",
  "item.minecraft.diamond_shovel": "Rhaw Diemwnt",
  "item.minecraft.diamond_spear": "Picell Ddiemwnt",
  "item.minecraft.diamond_sword": "Cleddyf Diemwnt",
  "item.minecraft.disc_fragment_5": "Darn o ddisg",
  "item.minecraft.disc_fragment_5.desc": "Disg Cerddoriaeth - 5",
  "item.minecraft.dolphin_spawn_egg": "Wy Geni Dolffin",
  "item.minecraft.donkey_spawn_egg": "Wy Geni Asyn",
  "item.minecraft.dragon_breath": "Gwynt y Ddraig",
  "item.minecraft.dried_kelp": "Gwymon Sych",
  "item.minecraft.drowned_spawn_egg": "Wy Geni Boddedig",
  "item.minecraft.dune_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Addurn Arfwisg Twyn",
  "item.minecraft.echo_shard": "Darn Adlais",
  "item.minecraft.egg": "Wy",
  "item.minecraft.elder_guardian_spawn_egg": "Wy Geni Gwarchodwr Hyn",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Emrallt",
  "item.minecraft.enchanted_book": "Llyfr Hudolus",
  "item.minecraft.enchanted_golden_apple": "Afal Euraid Hudolus",
  "item.minecraft.end_crystal": "Crisial End",
  "item.minecraft.ender_dragon_spawn_egg": "Wy Geni Draig Ender",
  "item.minecraft.ender_eye": "Llygad Ender",
  "item.minecraft.ender_pearl": "Perl Ender",
  "item.minecraft.enderman_spawn_egg": "Wy Geni Enderman",
  "item.minecraft.endermite_spawn_egg": "Wy Geni Endermite",
  "item.minecraft.evoker_spawn_egg": "Wy Geni Consuriwr",
  "item.minecraft.experience_bottle": "Potel Hudoliaeth",
  "item.minecraft.explorer_pottery_shard": "Darn Crochenwaith Anturwr",
  "item.minecraft.explorer_pottery_sherd": "Darn Crochenwaith Anturwr",
  "item.minecraft.eye_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Addurn Arfwisg Llygad",
  "item.minecraft.feather": "Pluen",
  "item.minecraft.fermented_spider_eye": "Llygad Pryf Cop Wedi Eplesu",
  "item.minecraft.field_masoned_banner_pattern": "Patrwm Baner Maes Saernïwyd",
  "item.minecraft.filled_map": "Map",
  "item.minecraft.fire_charge": "Pelen Dân",
  "item.minecraft.firework_rocket": "Roced Tân Gwyllt",
  "item.minecraft.firework_rocket.flight": "Hyd Hedfan:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Seren Tân Gwyllt",
  "item.minecraft.firework_star.black": "Du",
  "item.minecraft.firework_star.blue": "Glas",
  "item.minecraft.firework_star.brown": "Brown",
  "item.minecraft.firework_star.custom_color": "Addasu",
  "item.minecraft.firework_star.cyan": "Gwyrddlas",
  "item.minecraft.firework_star.fade_to": "Pylu i",
  "item.minecraft.firework_star.flicker": "Twincl",
  "item.minecraft.firework_star.gray": "Llwyd",
  "item.minecraft.firework_star.green": "Gwyrdd",
  "item.minecraft.firework_star.light_blue": "Glas Golau",
  "item.minecraft.firework_star.light_gray": "Llwyd Golau",
  "item.minecraft.firework_star.lime": "Leim",
  "item.minecraft.firework_star.magenta": "Majenta",
  "item.minecraft.firework_star.orange": "Oren",
  "item.minecraft.firework_star.pink": "Pinc",
  "item.minecraft.firework_star.purple": "Porffor",
  "item.minecraft.firework_star.red": "Coch",
  "item.minecraft.firework_star.shape": "Siâp Anhysbys",
  "item.minecraft.firework_star.shape.burst": "Byrst",
  "item.minecraft.firework_star.shape.creeper": "Siap Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Pelen Fawr",
  "item.minecraft.firework_star.shape.small_ball": "Pelen Fach",
  "item.minecraft.firework_star.shape.star": "Siâp Seren",
  "item.minecraft.firework_star.trail": "Llwybr",
  "item.minecraft.firework_star.white": "Gwyn",
  "item.minecraft.firework_star.yellow": "Melyn",
  "item.minecraft.fishing_rod": "Gwialen Pysgota",
  "item.minecraft.flint": "Fflint",
  "item.minecraft.flint_and_steel": "Fflint a Dur",
  "item.minecraft.flow_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Addurn Arfwisg Llif",
  "item.minecraft.flow_banner_pattern": "Patrwm Baner",
  "item.minecraft.flow_banner_pattern.desc": "Llif",
  "item.minecraft.flow_banner_pattern.new": "Patrwm Baner Llif",
  "item.minecraft.flow_pottery_sherd": "Darn Crochenwaith Llif",
  "item.minecraft.flower_banner_pattern": "Patrwm Baner",
  "item.minecraft.flower_banner_pattern.desc": "Luws Blodyn",
  "item.minecraft.flower_banner_pattern.new": "Patrwm Baner Luws Blodyn",
  "item.minecraft.flower_pot": "Pot Blodau",
  "item.minecraft.fox_spawn_egg": "Wy Geni Llwynog",
  "item.minecraft.friend_pottery_shard": "Darn Crochenwaith Ffrind",
  "item.minecraft.friend_pottery_sherd": "Darn Crochenwaith Ffrind",
  "item.minecraft.frog_spawn_egg": "Wy Geni Llyffant",
  "item.minecraft.furnace_minecart": "Cart Pwll gyda Ffwrnais",
  "item.minecraft.ghast_spawn_egg": "Wy Geni Ghast",
  "item.minecraft.ghast_tear": "Deigryn Ghast",
  "item.minecraft.glass_bottle": "Potel Gwydr",
  "item.minecraft.glistering_melon_slice": "Tafell Melon Euraid",
  "item.minecraft.globe_banner_pattern": "Patrwm Baner",
  "item.minecraft.globe_banner_pattern.desc": "Glôb",
  "item.minecraft.globe_banner_pattern.new": "Patrwm Baner Glôb",
  "item.minecraft.glow_berries": "Eirin Gloyw",
  "item.minecraft.glow_ink_sac": "Coden Inc Gloyw",
  "item.minecraft.glow_item_frame": "Ffrâm Eitem Gloyw",
  "item.minecraft.glow_squid_spawn_egg": "Wy Geni Ystifflog Gloyw",
  "item.minecraft.glowstone_dust": "Llwch Gloywgarreg",
  "item.minecraft.goat_horn": "Corn Gafr",
  "item.minecraft.goat_spawn_egg": "Wy Geni Gafr",
  "item.minecraft.gold_ingot": "Bar Aur",
  "item.minecraft.gold_nugget": "Clap Aur",
  "item.minecraft.golden_apple": "Afal Euraid",
  "item.minecraft.golden_axe": "Bwyell Aur",
  "item.minecraft.golden_boots": "Esgidiau Aur",
  "item.minecraft.golden_carrot": "Moronen Euraid",
  "item.minecraft.golden_chestplate": "Dwyfronneg Aur",
  "item.minecraft.golden_helmet": "Helmed Aur",
  "item.minecraft.golden_hoe": "Hof Aur",
  "item.minecraft.golden_horse_armor": "Arfwisg Ceffyl Euraid",
  "item.minecraft.golden_leggings": "Legins Aur",
  "item.minecraft.golden_nautilus_armor": "Arfwisg Nawtilws Aur",
  "item.minecraft.golden_pickaxe": "Caib Aur",
  "item.minecraft.golden_shovel": "Rhaw Aur",
  "item.minecraft.golden_spear": "Picell Aur",
  "item.minecraft.golden_sword": "Cleddyf Aur",
  "item.minecraft.gray_bundle": "Bwndel Llwyd",
  "item.minecraft.gray_dye": "Llifyn Llwyd",
  "item.minecraft.gray_harness": "Harnais Llwyd",
  "item.minecraft.green_bundle": "Bwndel Gwyrdd",
  "item.minecraft.green_dye": "Llifyn Gwyrdd",
  "item.minecraft.green_harness": "Harnais Gwyrdd",
  "item.minecraft.guardian_spawn_egg": "Wy Geni Gwarchodwr",
  "item.minecraft.gunpowder": "Powdr Gwn",
  "item.minecraft.guster_banner_pattern": "Patrwm Baner",
  "item.minecraft.guster_banner_pattern.desc": "Hwrdd",
  "item.minecraft.guster_banner_pattern.new": "Patrwm Baner Hwrdd",
  "item.minecraft.guster_pottery_sherd": "Darn Crochenwaith Hwrdd",
  "item.minecraft.happy_ghast_spawn_egg": "Wy Geni Ghast Hapus",
  "item.minecraft.harness": "Harnais",
  "item.minecraft.heart_of_the_sea": "Calon y Môr",
  "item.minecraft.heart_pottery_shard": "Darn Crochenwaith Calon",
  "item.minecraft.heart_pottery_sherd": "Darn Crochenwaith Calon",
  "item.minecraft.heartbreak_pottery_shard": "Darn Crochenwaith Torcalon",
  "item.minecraft.heartbreak_pottery_sherd": "Darn Crochenwaith Torcalon",
  "item.minecraft.hoglin_spawn_egg": "Ŵy Geni Hoglin",
  "item.minecraft.honey_bottle": "Potel Fêl",
  "item.minecraft.honeycomb": "Dil Mêl",
  "item.minecraft.hopper_minecart": "Cart Pwll gyda Hopran",
  "item.minecraft.horse_spawn_egg": "Wy Geni Ceffyl",
  "item.minecraft.host_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.host_armor_trim_smithing_template.new": "Addurn Arfwisg Lletywr",
  "item.minecraft.howl_pottery_shard": "Darn Crochenwaith Blaidd",
  "item.minecraft.howl_pottery_sherd": "Darn Crochenwaith Blaidd",
  "item.minecraft.husk_spawn_egg": "Wy Geni Cibyn",
  "item.minecraft.ink_sac": "Coden Inc",
  "item.minecraft.iron_axe": "Bwyell Haearn",
  "item.minecraft.iron_boots": "Esgidiau Haearn",
  "item.minecraft.iron_chestplate": "Dwyfronneg Haearn",
  "item.minecraft.iron_golem_spawn_egg": "Wy Geni Golem Haearn",
  "item.minecraft.iron_helmet": "Helmed Haearn",
  "item.minecraft.iron_hoe": "Hof Haearn",
  "item.minecraft.iron_horse_armor": "Arfwisg Ceffyl Haearn",
  "item.minecraft.iron_ingot": "Bar Haearn",
  "item.minecraft.iron_leggings": "Legins Haearn",
  "item.minecraft.iron_nautilus_armor": "Arfwisg Nawtilws Haearn",
  "item.minecraft.iron_nugget": "Clap Haearn",
  "item.minecraft.iron_pickaxe": "Caib Haearn",
  "item.minecraft.iron_shovel": "Rhaw Haearn",
  "item.minecraft.iron_spear": "Picell Haearn",
  "item.minecraft.iron_sword": "Cleddyf Haearn",
  "item.minecraft.item_frame": "Ffrâm Eitem",
  "item.minecraft.jungle_boat": "Cwch Jyngl",
  "item.minecraft.jungle_chest_boat": "Cwch Jyngl â Chist",
  "item.minecraft.knowledge_book": "Llyfr Gwybodaeth",
  "item.minecraft.lapis_lazuli": "Lapis-Laswli",
  "item.minecraft.lava_bucket": "Bwced Lafa",
  "item.minecraft.lead": "Tennyn",
  "item.minecraft.leather": "Lledr",
  "item.minecraft.leather_boots": "Esgidiau Lledr",
  "item.minecraft.leather_chestplate": "Tiwnig Lledr",
  "item.minecraft.leather_helmet": "Het Lledr",
  "item.minecraft.leather_horse_armor": "Arfwisg Ceffyl Lledr",
  "item.minecraft.leather_leggings": "Trowser Lledr",
  "item.minecraft.light_blue_bundle": "Bwndel Glas Golau",
  "item.minecraft.light_blue_dye": "Llifyn Glas Golau",
  "item.minecraft.light_blue_harness": "Harnais Glas Golau",
  "item.minecraft.light_gray_bundle": "Bwndel Llwyd Golau",
  "item.minecraft.light_gray_dye": "Llifyn Llwyd Golau",
  "item.minecraft.light_gray_harness": "Harnais Llwyd Golau",
  "item.minecraft.lime_bundle": "Bwndel Leim",
  "item.minecraft.lime_dye": "Llifyn Leim",
  "item.minecraft.lime_harness": "Harnais Leim",
  "item.minecraft.lingering_potion": "Diod Parhaus",
  "item.minecraft.lingering_potion.effect.awkward": "Diod Parhaus Lletchwith",
  "item.minecraft.lingering_potion.effect.empty": "Diod Parhaus Anghrefftadwy",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Diod Parhaus Gwrthsefyll Tân",
  "item.minecraft.lingering_potion.effect.harming": "Diod Parhaus Niweidio",
  "item.minecraft.lingering_potion.effect.healing": "Diod Parhaus Iachau",
  "item.minecraft.lingering_potion.effect.infested": "Diod Pla Parhaus",
  "item.minecraft.lingering_potion.effect.invisibility": "Diod Parhaus Anweledigaeth",
  "item.minecraft.lingering_potion.effect.leaping": "Diod Parhaus Neidio",
  "item.minecraft.lingering_potion.effect.levitation": "Diod Parhaus o Ymddyrchafael",
  "item.minecraft.lingering_potion.effect.luck": "Diod Parhaus Lwc",
  "item.minecraft.lingering_potion.effect.mundane": "Diod Parhaus Cyffredin",
  "item.minecraft.lingering_potion.effect.night_vision": "Diod Parhaus Golwg Nos",
  "item.minecraft.lingering_potion.effect.oozing": "Diod Lleidiog Parhaus",
  "item.minecraft.lingering_potion.effect.poison": "Diod Parhaus Gwenwyn",
  "item.minecraft.lingering_potion.effect.regeneration": "Diod Parhaus Adfywio",
  "item.minecraft.lingering_potion.effect.slow_falling": "Diod Parhaus Syrthio Araf",
  "item.minecraft.lingering_potion.effect.slowness": "Diod Parhaus Arafiad",
  "item.minecraft.lingering_potion.effect.strength": "Diod Parhaus Cryfhau",
  "item.minecraft.lingering_potion.effect.swiftness": "Diod Parhaus o Gyflymiad",
  "item.minecraft.lingering_potion.effect.thick": "Diod Parhaus Trwchus",
  "item.minecraft.lingering_potion.effect.turtle_master": "Diod Parhaus y Meistr Crwbanod",
  "item.minecraft.lingering_potion.effect.water": "Potel Ddŵr Parhaus",
  "item.minecraft.lingering_potion.effect.water_breathing": "Diod Parhaus Anadlu Dŵr",
  "item.minecraft.lingering_potion.effect.weakness": "Diod Parhaus o Wendid",
  "item.minecraft.lingering_potion.effect.weaving": "Diod Gwau Parhaus",
  "item.minecraft.lingering_potion.effect.wind_charged": "Diod Hyrddiad Gwynt Parhaus",
  "item.minecraft.llama_spawn_egg": "Wy Gemi Lama",
  "item.minecraft.lodestone_compass": "Cwmpawd Tynfaen",
  "item.minecraft.mace": "Pastwn",
  "item.minecraft.magenta_bundle": "Bwndel Majenta",
  "item.minecraft.magenta_dye": "Llifyn Majenta",
  "item.minecraft.magenta_harness": "Harnais Majenta",
  "item.minecraft.magma_cream": "Hufen Magma",
  "item.minecraft.magma_cube_spawn_egg": "Wy Geni Ciwb Magma",
  "item.minecraft.mangrove_boat": "Cwch Mangrof",
  "item.minecraft.mangrove_chest_boat": "Cwch Mangrof â Chist",
  "item.minecraft.map": "Map Gwag",
  "item.minecraft.melon_seeds": "Hadau Melon",
  "item.minecraft.melon_slice": "Tafell Melon",
  "item.minecraft.milk_bucket": "Bwced Llaeth",
  "item.minecraft.minecart": "Cart Pwll",
  "item.minecraft.miner_pottery_shard": "Darn Crochenwaith Cloddio",
  "item.minecraft.miner_pottery_sherd": "Darn Crochenwaith Cloddio",
  "item.minecraft.mojang_banner_pattern": "Patrwm Baner",
  "item.minecraft.mojang_banner_pattern.desc": "Peth",
  "item.minecraft.mojang_banner_pattern.new": "Patrwm Baner Peth",
  "item.minecraft.mooshroom_spawn_egg": "Wy Geni Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Darn Crochenwaith Galaru",
  "item.minecraft.mourner_pottery_sherd": "Darn Crochenwaith Galaru",
  "item.minecraft.mule_spawn_egg": "Wy Geni Mul",
  "item.minecraft.mushroom_stew": "Cawl Madarch",
  "item.minecraft.music_disc_11": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Bocs Cerddoriaeth)",
  "item.minecraft.music_disc_far": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disg Cerddoriaeth",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Cig Dafad Amrwd",
  "item.minecraft.name_tag": "Tag Enw",
  "item.minecraft.nautilus_shell": "Cragen Bedr",
  "item.minecraft.nautilus_spawn_egg": "Wy Geni Nawtilws",
  "item.minecraft.nether_brick": "Bricsen Nether",
  "item.minecraft.nether_star": "Seren Nether",
  "item.minecraft.nether_wart": "Chwyn Nether",
  "item.minecraft.netherite_axe": "Bwyell Netherit",
  "item.minecraft.netherite_boots": "Esgidiau Netherit",
  "item.minecraft.netherite_chestplate": "Dwyfronneg Netherit",
  "item.minecraft.netherite_helmet": "Helmed Netherit",
  "item.minecraft.netherite_hoe": "Hof Netherit",
  "item.minecraft.netherite_horse_armor": "Arfwisg Ceffyl Netherit",
  "item.minecraft.netherite_ingot": "Bar Netherit",
  "item.minecraft.netherite_leggings": "Legins Netherit",
  "item.minecraft.netherite_nautilus_armor": "Arfwisg Nawtilws Netherit",
  "item.minecraft.netherite_pickaxe": "Caib Netherit",
  "item.minecraft.netherite_scrap": "Sgrap Netherit",
  "item.minecraft.netherite_shovel": "Rhaw Netherit",
  "item.minecraft.netherite_spear": "Picell Netherit",
  "item.minecraft.netherite_sword": "Cleddyf Netherit",
  "item.minecraft.netherite_upgrade_smithing_template": "Templed Gof",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Uwchraddiad Netherit",
  "item.minecraft.oak_boat": "Cwch Derw",
  "item.minecraft.oak_chest_boat": "Cwch Derw â Chist",
  "item.minecraft.ocelot_spawn_egg": "Wy Geni Oselot",
  "item.minecraft.ominous_bottle": "Potel Ddrwgargoelus",
  "item.minecraft.ominous_trial_key": "Allwedd Treial Ddrwgargoelus",
  "item.minecraft.orange_bundle": "Bwndel Oren",
  "item.minecraft.orange_dye": "Llifyn Oren",
  "item.minecraft.orange_harness": "Harnais Oren",
  "item.minecraft.painting": "Llun",
  "item.minecraft.pale_oak_boat": "Cwch Derw Llwyd",
  "item.minecraft.pale_oak_chest_boat": "Cwch Derw Llwyd â Chist",
  "item.minecraft.panda_spawn_egg": "Wy Geni Panda",
  "item.minecraft.paper": "Papur",
  "item.minecraft.parched_spawn_egg": "Wy Geni Sychedig",
  "item.minecraft.parrot_spawn_egg": "Wy Geni Parot",
  "item.minecraft.phantom_membrane": "Pilen Ffantom",
  "item.minecraft.phantom_spawn_egg": "Wy Geni Ffantom",
  "item.minecraft.pig_spawn_egg": "Wy Geni Mochyn",
  "item.minecraft.piglin_banner_pattern": "Patrwm Baner",
  "item.minecraft.piglin_banner_pattern.desc": "Trwyn",
  "item.minecraft.piglin_banner_pattern.new": "Patrwm Baner Trwyn",
  "item.minecraft.piglin_brute_spawn_egg": "Wy Geni Piglin Brwnt",
  "item.minecraft.piglin_spawn_egg": "Wy Geni Piglin",
  "item.minecraft.pillager_spawn_egg": "Wy Geni Ysbeiliwr",
  "item.minecraft.pink_bundle": "Bwndel Pinc",
  "item.minecraft.pink_dye": "Llifyn Pinc",
  "item.minecraft.pink_harness": "Harnais Pinc",
  "item.minecraft.pitcher_plant": "Piserlys",
  "item.minecraft.pitcher_pod": "Pod Piserlys",
  "item.minecraft.plenty_pottery_shard": "Darn Crochenwaith Digonedd",
  "item.minecraft.plenty_pottery_sherd": "Darn Crochenwaith Digonedd",
  "item.minecraft.poisonous_potato": "Taten Gwenwynig",
  "item.minecraft.polar_bear_spawn_egg": "Wy Geni Arth Wen",
  "item.minecraft.popped_chorus_fruit": "Ffrwyth Corws wedi Phopio",
  "item.minecraft.porkchop": "Porc Amrwd",
  "item.minecraft.potato": "Taten",
  "item.minecraft.potion": "Diod",
  "item.minecraft.potion.effect.awkward": "Diod Lletchwith",
  "item.minecraft.potion.effect.empty": "Diod Anghrefftadwy",
  "item.minecraft.potion.effect.fire_resistance": "Diod Gwrthsefyll Tân",
  "item.minecraft.potion.effect.harming": "Diod Niweidio",
  "item.minecraft.potion.effect.healing": "Diod Iachau",
  "item.minecraft.potion.effect.infested": "Diod Pla",
  "item.minecraft.potion.effect.invisibility": "Diod Anweledigaeth",
  "item.minecraft.potion.effect.leaping": "Diod Neidio",
  "item.minecraft.potion.effect.levitation": "Diod o Ymddyrchafael",
  "item.minecraft.potion.effect.luck": "Diod Lwc",
  "item.minecraft.potion.effect.mundane": "Diod Cyffredin",
  "item.minecraft.potion.effect.night_vision": "Diod Golwg Nos",
  "item.minecraft.potion.effect.oozing": "Diod Lleidiog",
  "item.minecraft.potion.effect.poison": "Diod Gwenwyn",
  "item.minecraft.potion.effect.regeneration": "Diod Adfywio",
  "item.minecraft.potion.effect.slow_falling": "Diod Syrthio Araf",
  "item.minecraft.potion.effect.slowness": "Diod Arafiad",
  "item.minecraft.potion.effect.strength": "Diod Cryfhau",
  "item.minecraft.potion.effect.swiftness": "Diod o Gyflymiad",
  "item.minecraft.potion.effect.thick": "Diod Trwchus",
  "item.minecraft.potion.effect.turtle_master": "Diod y Meistr Crwbanod",
  "item.minecraft.potion.effect.water": "Potel Ddŵr",
  "item.minecraft.potion.effect.water_breathing": "Diod Anadlu Dŵr",
  "item.minecraft.potion.effect.weakness": "Diod o Wendid",
  "item.minecraft.potion.effect.weaving": "Diod Gwau",
  "item.minecraft.potion.effect.wind_charged": "Diod Hyrddiad Gwynt",
  "item.minecraft.pottery_shard_archer": "Darn Crochenwaith Saethwr",
  "item.minecraft.pottery_shard_arms_up": "Darn Crochenwaith Breichiau",
  "item.minecraft.pottery_shard_prize": "Darn Crochenwaith Gwobr",
  "item.minecraft.pottery_shard_skull": "Darn Crochenwaith Penglog",
  "item.minecraft.powder_snow_bucket": "Bwced Eira Powdr",
  "item.minecraft.prismarine_crystals": "Crisialau Prismarin",
  "item.minecraft.prismarine_shard": "Telchyn Prismarin",
  "item.minecraft.prize_pottery_shard": "Darn Crochenwaith Gwobr",
  "item.minecraft.prize_pottery_sherd": "Darn Crochenwaith Gwobr",
  "item.minecraft.pufferfish": "Chwyddbysgodyn",
  "item.minecraft.pufferfish_bucket": "Bwced o Chwyddbysgod",
  "item.minecraft.pufferfish_spawn_egg": "Wy Geni Chwyddbysgodyn",
  "item.minecraft.pumpkin_pie": "Pei Pwmpen",
  "item.minecraft.pumpkin_seeds": "Hadau Pwmpen",
  "item.minecraft.purple_bundle": "Bwndel Porffor",
  "item.minecraft.purple_dye": "Llifyn Porffor",
  "item.minecraft.purple_harness": "Harnais Porffor",
  "item.minecraft.quartz": "Cwarts Nether",
  "item.minecraft.rabbit": "Cwningen Amrwd",
  "item.minecraft.rabbit_foot": "Troed Cwningen",
  "item.minecraft.rabbit_hide": "Croen Cwningen",
  "item.minecraft.rabbit_spawn_egg": "Wy Geni Cwningen",
  "item.minecraft.rabbit_stew": "Cawl Cwningen",
  "item.minecraft.raiser_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Addurn Arfwisg Codwr",
  "item.minecraft.ravager_spawn_egg": "Wy Geni Difrodwr",
  "item.minecraft.raw_copper": "Copr Crai",
  "item.minecraft.raw_gold": "Aur Crai",
  "item.minecraft.raw_iron": "Haearn Crai",
  "item.minecraft.recovery_compass": "Cwmpawd Adennill",
  "item.minecraft.red_bundle": "Bwndel Coch",
  "item.minecraft.red_dye": "Llifyn Coch",
  "item.minecraft.red_harness": "Harnais Coch",
  "item.minecraft.redstone": "Llwch Redstone",
  "item.minecraft.resin_brick": "Bric Resin",
  "item.minecraft.resin_clump": "Talp Resin",
  "item.minecraft.rib_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Addurn Arfwisg Asen",
  "item.minecraft.rotten_flesh": "Cnawd Pwdr",
  "item.minecraft.saddle": "Cyfrwy",
  "item.minecraft.salmon": "Eog Amrwd",
  "item.minecraft.salmon_bucket": "Bwced o Eog",
  "item.minecraft.salmon_spawn_egg": "Wy Geni Eog",
  "item.minecraft.scrape_pottery_sherd": "Darn Crochenwaith Crafu",
  "item.minecraft.scute": "Sgwtela",
  "item.minecraft.sentry_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Addurn Arfwisg Gwyliwr",
  "item.minecraft.shaper_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Addurn Arfwisg Siapiwr",
  "item.minecraft.sheaf_pottery_shard": "Darn Crochenwaith Ysgub",
  "item.minecraft.sheaf_pottery_sherd": "Darn Crochenwaith Ysgub",
  "item.minecraft.shears": "Gwellau",
  "item.minecraft.sheep_spawn_egg": "Wy Geni Dafad",
  "item.minecraft.shelter_pottery_shard": "Darn Crochenwaith Cysgod",
  "item.minecraft.shelter_pottery_sherd": "Darn Crochenwaith Cysgod",
  "item.minecraft.shield": "Tarian",
  "item.minecraft.shield.black": "Tarian Ddu",
  "item.minecraft.shield.blue": "Tarian Las",
  "item.minecraft.shield.brown": "Tarian Frown",
  "item.minecraft.shield.cyan": "Tarian Wyrddlas",
  "item.minecraft.shield.gray": "Tarian Lwyd",
  "item.minecraft.shield.green": "Tarian Werdd",
  "item.minecraft.shield.light_blue": "Tarian Las Golau",
  "item.minecraft.shield.light_gray": "Tarian Lwyd Golau",
  "item.minecraft.shield.lime": "Tarian Leim",
  "item.minecraft.shield.magenta": "Tarian Majenta",
  "item.minecraft.shield.orange": "Tarian Oren",
  "item.minecraft.shield.pink": "Tarian Binc",
  "item.minecraft.shield.purple": "Tarian Borffor",
  "item.minecraft.shield.red": "Tarian Goch",
  "item.minecraft.shield.white": "Tarian Wen",
  "item.minecraft.shield.yellow": "Tarian Felen",
  "item.minecraft.shulker_shell": "Cragen Shulker",
  "item.minecraft.shulker_spawn_egg": "Wy Geni Shulker",
  "item.minecraft.sign": "Arwydd",
  "item.minecraft.silence_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Addurn Arfwisg Tawelwch",
  "item.minecraft.silverfish_spawn_egg": "Wy Geni Pryf Arian",
  "item.minecraft.skeleton_horse_spawn_egg": "Wy Geni Ceffyl Sgerbwd",
  "item.minecraft.skeleton_spawn_egg": "Wy Geni Sgerbwd",
  "item.minecraft.skull_banner_pattern": "Patrwm Baner",
  "item.minecraft.skull_banner_pattern.desc": "Luws Penglog",
  "item.minecraft.skull_banner_pattern.new": "Patrwm Baner Luws Penglog",
  "item.minecraft.skull_pottery_shard": "Darn Crochenwaith Penglog",
  "item.minecraft.skull_pottery_sherd": "Darn Crochenwaith Penglog",
  "item.minecraft.slime_ball": "Pelen Sleim",
  "item.minecraft.slime_spawn_egg": "Wy Geni Sleim",
  "item.minecraft.smithing_template": "Templed Gof",
  "item.minecraft.smithing_template.applies_to": "Ar gyfer:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Ychwanegu bar neu grisial",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Arfwisg",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Ychwanegu ddarn o arfwisg",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Bariau & Crisialau",
  "item.minecraft.smithing_template.ingredients": "Cynhwysion:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Ychwanegu Bar Netherit",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Offer Diemwnt",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Ychwanegu arfwisg, arf neu offer diemwnt",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Bar Netherit",
  "item.minecraft.smithing_template.upgrade": "Uwchraddio: ",
  "item.minecraft.sniffer_spawn_egg": "Wy Geni Ffroenwr",
  "item.minecraft.snort_pottery_shard": "Darn Crochenwaith Trwyn",
  "item.minecraft.snort_pottery_sherd": "Darn Crochenwaith Trwyn",
  "item.minecraft.snout_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Addurn Arfwisg Trwyn",
  "item.minecraft.snow_golem_spawn_egg": "Wy Geni Golem Eira",
  "item.minecraft.snowball": "Pelen Eira",
  "item.minecraft.spectral_arrow": "Saeth Sbectrol",
  "item.minecraft.spider_eye": "Llygad Pryf Cop",
  "item.minecraft.spider_spawn_egg": "Wy Geni Pryf Cop",
  "item.minecraft.spire_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Addurn Arfwisg Tŵr",
  "item.minecraft.splash_potion": "Diod Tasgu",
  "item.minecraft.splash_potion.effect.awkward": "Diod Tasgu Lletchwith",
  "item.minecraft.splash_potion.effect.empty": "Diod Tasgu Anghrefftadwy",
  "item.minecraft.splash_potion.effect.fire_resistance": "Diod Tasgu Gwrthsefyll Tân",
  "item.minecraft.splash_potion.effect.harming": "Diod Tasgu Niweidio",
  "item.minecraft.splash_potion.effect.healing": "Diod Tasgu Iachau",
  "item.minecraft.splash_potion.effect.infested": "Diod Sblash o Bla",
  "item.minecraft.splash_potion.effect.invisibility": "Diod Tasgu Anweledigaeth",
  "item.minecraft.splash_potion.effect.leaping": "Diod Tasgu Neidio",
  "item.minecraft.splash_potion.effect.levitation": "Diod Tasgu o Ymddyrchafael",
  "item.minecraft.splash_potion.effect.luck": "Diod Tasgu Lwc",
  "item.minecraft.splash_potion.effect.mundane": "Diod Tasgu Cyffredin",
  "item.minecraft.splash_potion.effect.night_vision": "Diod Tasgu Golwg Nos",
  "item.minecraft.splash_potion.effect.oozing": "Diod Sblash Lleidiog",
  "item.minecraft.splash_potion.effect.poison": "Diod Tasgu Gwenwyn",
  "item.minecraft.splash_potion.effect.regeneration": "Diod Tasgu Adfywio",
  "item.minecraft.splash_potion.effect.slow_falling": "Diod Tasgu Syrthio Araf",
  "item.minecraft.splash_potion.effect.slowness": "Diod Tasgu Arafiad",
  "item.minecraft.splash_potion.effect.strength": "Diod Tasgu Cryfhau",
  "item.minecraft.splash_potion.effect.swiftness": "Diod Tasgu o Gyflymiad",
  "item.minecraft.splash_potion.effect.thick": "Diod Tasgu Trwchus",
  "item.minecraft.splash_potion.effect.turtle_master": "Diod Tasgu y Meistr Crwbanod",
  "item.minecraft.splash_potion.effect.water": "Potel Ddŵr Tasgu",
  "item.minecraft.splash_potion.effect.water_breathing": "Diod Tasgu Anadlu Dŵr",
  "item.minecraft.splash_potion.effect.weakness": "Diod Tasgu o Wendid",
  "item.minecraft.splash_potion.effect.weaving": "Diod Sblash Gwau",
  "item.minecraft.splash_potion.effect.wind_charged": "Diod Sblash Hyrddiad Gwynt",
  "item.minecraft.spruce_boat": "Cwch Pyrwydd",
  "item.minecraft.spruce_chest_boat": "Cwch Pyrwydd â Chist",
  "item.minecraft.spyglass": "Sbinglas",
  "item.minecraft.squid_spawn_egg": "Wy Geni Ystifflog",
  "item.minecraft.stick": "Ffon",
  "item.minecraft.stone_axe": "Bwyell Carreg",
  "item.minecraft.stone_hoe": "Hof Carreg",
  "item.minecraft.stone_pickaxe": "Caib Carreg",
  "item.minecraft.stone_shovel": "Rhaw Carreg",
  "item.minecraft.stone_spear": "Picell Garreg",
  "item.minecraft.stone_sword": "Cleddyf Carreg",
  "item.minecraft.stray_spawn_egg": "Wy Geni Crwydryn",
  "item.minecraft.strider_spawn_egg": "Ŵy Geni Brasgamwr",
  "item.minecraft.string": "Llinyn",
  "item.minecraft.sugar": "Siwgr",
  "item.minecraft.suspicious_stew": "Cawl Amheus",
  "item.minecraft.sweet_berries": "Aeron Melys",
  "item.minecraft.tadpole_bucket": "Bwced o Benbwl",
  "item.minecraft.tadpole_spawn_egg": "Wy Geni Penbwl",
  "item.minecraft.tide_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Addurn Arfwisg Llanw",
  "item.minecraft.tipped_arrow": "Saeth wedi'i Drochi",
  "item.minecraft.tipped_arrow.effect.awkward": "Saeth wedi'i Drochi",
  "item.minecraft.tipped_arrow.effect.empty": "Saeth wedi'i Drochi Anghrefftadwy",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Saeth Gwrthsefyll Tân",
  "item.minecraft.tipped_arrow.effect.harming": "Saeth Niweidio",
  "item.minecraft.tipped_arrow.effect.healing": "Saeth Iachau",
  "item.minecraft.tipped_arrow.effect.infested": "Saeth Pla",
  "item.minecraft.tipped_arrow.effect.invisibility": "Saeth Anweledigaeth",
  "item.minecraft.tipped_arrow.effect.leaping": "Saeth Neidio",
  "item.minecraft.tipped_arrow.effect.levitation": "Saeth o Ymddyrchafael",
  "item.minecraft.tipped_arrow.effect.luck": "Saeth Lwc",
  "item.minecraft.tipped_arrow.effect.mundane": "Saeth wedi'i Drochi",
  "item.minecraft.tipped_arrow.effect.night_vision": "Saeth Golwg Nos",
  "item.minecraft.tipped_arrow.effect.oozing": "Saeth Lleidiog",
  "item.minecraft.tipped_arrow.effect.poison": "Saeth Gwenwyn",
  "item.minecraft.tipped_arrow.effect.regeneration": "Saeth Adfywio",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Saeth Syrthio Araf",
  "item.minecraft.tipped_arrow.effect.slowness": "Saeth Arafiad",
  "item.minecraft.tipped_arrow.effect.strength": "Saeth Cryfhau",
  "item.minecraft.tipped_arrow.effect.swiftness": "Saeth o Gyflymiad",
  "item.minecraft.tipped_arrow.effect.thick": "Saeth wedi'i Drochi",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Saeth y Meistr Crwbanod",
  "item.minecraft.tipped_arrow.effect.water": "Saeth Tasgu",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Saeth Anadlu Dŵr",
  "item.minecraft.tipped_arrow.effect.weakness": "Saeth o Wendid",
  "item.minecraft.tipped_arrow.effect.weaving": "Saeth Gwau",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Saeth Hyrddiad Gwynt",
  "item.minecraft.tnt_minecart": "Cart Pwll gyda TNT",
  "item.minecraft.torchflower_seeds": "Hadau Torsflodyn",
  "item.minecraft.totem_of_undying": "Totem Anfarwol",
  "item.minecraft.trader_llama_spawn_egg": "Wy Geni Lama Masnachwr",
  "item.minecraft.trial_key": "Allwedd Treial",
  "item.minecraft.trident": "Tryfer",
  "item.minecraft.tropical_fish": "Pysgodyn Trofannol",
  "item.minecraft.tropical_fish_bucket": "Bwced o Bysgod Trofannol",
  "item.minecraft.tropical_fish_spawn_egg": "Wy Geni Pysgodyn Trofannol",
  "item.minecraft.turtle_helmet": "Cragen Crwban",
  "item.minecraft.turtle_scute": "Sgwtela Crwban",
  "item.minecraft.turtle_spawn_egg": "Wy Geni Crwban y Môr",
  "item.minecraft.vex_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Addurn Arfwisg Aflonyddwr",
  "item.minecraft.vex_spawn_egg": "Wy Geni Cythral",
  "item.minecraft.villager_spawn_egg": "Wy Geni Pentrefwr",
  "item.minecraft.vindicator_spawn_egg": "Wy Geni Gwas",
  "item.minecraft.wandering_trader_spawn_egg": "Wy Geni Masnachwr Crwydrol",
  "item.minecraft.ward_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Addurn Arfwisg Wart",
  "item.minecraft.warden_spawn_egg": "Wy Geni Warden",
  "item.minecraft.warped_fungus_on_a_stick": "Ffwng Annaearol ar Ffon",
  "item.minecraft.water_bucket": "Bwced Dŵr",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Addurn Arfwisg Cyfeiriadu",
  "item.minecraft.wheat": "Gwenith",
  "item.minecraft.wheat_seeds": "Hadau Gwenith",
  "item.minecraft.white_bundle": "Bwndel Gwyn",
  "item.minecraft.white_dye": "Llifyn Gwyn",
  "item.minecraft.white_harness": "Harnais Gwyn",
  "item.minecraft.wild_armor_trim_smithing_template": "Templed Gof",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Addurn Arfwisg Gwyllt",
  "item.minecraft.wind_charge": "Hyrddiad Gwynt",
  "item.minecraft.witch_spawn_egg": "Wy Geni Gwrach",
  "item.minecraft.wither_skeleton_spawn_egg": "Wy Geni Sgerbwd Wither",
  "item.minecraft.wither_spawn_egg": "Wy Geni Wither",
  "item.minecraft.wolf_armor": "Arfwisg Blaidd",
  "item.minecraft.wolf_spawn_egg": "Wy Geni Blaidd",
  "item.minecraft.wooden_axe": "Bwyell Pren",
  "item.minecraft.wooden_hoe": "Hof Pren",
  "item.minecraft.wooden_pickaxe": "Caib Pren",
  "item.minecraft.wooden_shovel": "Rhaw Pren",
  "item.minecraft.wooden_spear": "Picell Bren",
  "item.minecraft.wooden_sword": "Cleddyf Pren",
  "item.minecraft.writable_book": "Llyfr a Chwilsen",
  "item.minecraft.written_book": "Llyfr a Ysgrifennwyd",
  "item.minecraft.yellow_bundle": "Bwndel Melyn",
  "item.minecraft.yellow_dye": "Llifyn Melyn",
  "item.minecraft.yellow_harness": "Harnais Melyn",
  "item.minecraft.zoglin_spawn_egg": "Wy Geni Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Wy Geni Ceffyl Sombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Wy Geni Nawtilws Sombi",
  "item.minecraft.zombie_spawn_egg": "Wy Geni Sombi",
  "item.minecraft.zombie_villager_spawn_egg": "Wy Geni Pentrefwr Sombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Wy Geni Piglin Sombi"
}
export const cy_gb = items; 
